<template>
    <div style="background: #f1f2f6;">
        <div class="containerb" style="margin: 0px auto;">
            <div style="width: 1200px;overflow-x: auto;user-select: none;" class="scroll-container"
                id="scrollcontainer">
                <div
                    style="display: flex;align-items: center;padding-top: 20px;width: 1500px;justify-content: space-between;">
                    <div @click="getInfo(w, j)"
                        :class="[{ 'mindex': w.title == mindex }, { 'menu': mindex != w.title }]"
                        style="margin: 10px 0px; padding:5px 20px;cursor: pointer;border-radius: 30px;font-size: 14px;color:#999999"
                        v-for="(w, j) in menu">{{
                            w.title }}
                    </div>
                </div>
            </div>

            <div style="margin-top: 5px;font-size: 14px;margin-left: 20px;">
                {{ data.text }}
            </div>

            <div v-if="data.title != 'AI智能体中台'">
                <div style="background: #fff;display: flex;align-items: center;padding:5px 5px;margin-top: 20px;">
                    <div style="position: relative;width: 80px;height: 36px;">
                        <img style="" src="../../assets/AI/bq.png" />
                        <div style="position: absolute;top: 6px;color: #fff;left: 11px;font-size: 14px;">应用详情</div>
                    </div>
                    <div style="font-size: 14px;margin-left: 10px;width: 1090px;">{{ data.info }}</div>
                </div>

                <div style="background: #fff;margin-top: 20px;padding-top: 50px;">
                    <div style="font-size: 28px;text-align: center;">
                        痛点与解决方案
                    </div>
                    <div style="margin-top: 20px;">
                        <img style="margin: 0px auto;" :src="data.img" />
                    </div>
                </div>

                <div style="background: #fff;padding-top: 50px;">
                    <div style="font-size: 28px;text-align: center;">核心功能</div>
                    <div
                        style="display: flex;align-items: center;justify-content: space-between;padding:0px 35px;margin-top: 50px;">
                        <div v-for="x in data.hxgn" style="width: 265px;"
                            :style="{ 'width': data.hxgn.length === 4 ? '265px' : '208px' }">
                            <div style="text-align: center;font-size: 14px;color: #fff;height: 30px;line-height: 30px; background-size: 100;width: 180px;margin: 0px auto;"
                                :style="{ backgroundImage: 'url(' + require('@/assets/AI/btk.png') + ')' }">
                                {{ x.title }}
                            </div>
                            <div
                                style="height: 210px;width: 100%;font-size: 14px;background: #f6fafd;padding: 20px;border-radius: 10px;line-height: 23px;">
                                {{ x.text }}
                            </div>
                        </div>
                    </div>
                </div>

                <div style="background: #fff;padding-top: 50px;">
                    <div style="padding: 38px;font-size: 28px;margin-left: 5px;text-align: center;">典型应用场景</div>
                    <div class="file flex-container"
                        style="flex-wrap: wrap;justify-content: space-between;align-items: center;padding:0px 35px;">
                        <div style="padding:28px 30px 28px 0px;" v-for="x in data.card" class="cardx">
                            <div class="file">
                                <div v-show="x.title"
                                    style="height: 60px;margin-top: 6px;border-left: 3px solid #1e66d1;"
                                    class="bprimary">
                                </div>
                                <div style="margin-left: 22px;width: 280px;">
                                    <div style="font-size: 18px;color: #1e66d1;" class="cprimary">{{ x.title }}
                                    </div>
                                    <div class="ftext" style="margin-top: 10px;line-height: 26px;">{{
                                        x.text
                                    }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="background: #fff;padding-top: 50px;padding-bottom: 50px;">
                    <div style="font-size: 28px;text-align: center;">核心价值</div>
                    <div style="height:280px;display: flex;align-items: center;justify-content:space-around;margin:0px 35px;margin-top: 50px;background-size: cover;"
                        :style="{ backgroundImage: 'url(' + require('@/assets/AI/hxjz.jpg') + ')' }">
                        <div v-for="x in data.hxjz">
                            <div
                                style="text-align: center;font-size: 18px;font-weight: bold; color:#1e66d1;margin: 0px auto;">
                                <div>{{ x.title }}{{ x.titleb }}</div>
                            </div>
                            <div style="background: #1e66d1;border-radius: 10px;"
                                :style="{ 'width': data.hxjz.length == 4 ? '242px' : '196px' }">
                                <div
                                    style="margin-top: 15px; height: 170px;font-size: 14px;background: #f6fafd;padding: 20px;border-radius: 10px;line-height: 23px;color: #000;position: relative;top: 5px;">
                                    {{ x.text }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="background: #fff;padding-top: 50px;padding-bottom: 50px;">
                    <div style="font-size: 28px;text-align: center;">功能展示</div>
                    <div
                        style="margin: 35px;border: 1px dashed #1e66d1;border-radius: 10px;padding: 0px 15px;padding-top: 30px;">
                        <div v-for="x in data.gnzs" style="margin: 0px 15px;margin-bottom: 35px;">
                            <img :src="x" style="margin: 0px auto;max-width: 1050px;">
                        </div>
                        <div
                            style="display: flex;align-items: end;justify-content: center;width: 100%;flex-wrap: wrap;">
                            <div v-for="x in data.gnzsb" style="margin: 0px 15px; margin-bottom: 35px;"
                                :style="{ 'width': x.width }">
                                <div><img :src="x.img" style="box-shadow: #e5eff6 -1px 8px 10px 0px;"></div>
                                <div v-show="x.title"
                                    style="height: 32px;line-height: 32px;font-size: 14px;text-align: center;background: #ececec;margin: 0px auto;margin-top: 20px;border-radius: 20px;padding: 0px 20px;display: table;">
                                    {{ x.title }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="AIMenu" v-else style="padding: 30px 0px;">
                <div class="slide slide-platform" data-index="5">
                    <div class="container">
                        <div class="platform-header">
                            <h1 class="platform-title">AI智能体中台</h1>
                            <p class="platform-subtitle">一站式AI应用平台，赋能企业智能化转型</p>
                        </div>

                        <div class="platform-content">
                            <!-- Left: Screenshot -->
                            <div class="platform-screenshot">
                                <img :src="require('./image/agent-center.png')" alt="智能体中心界面" class="screenshot-img">
                            </div>

                            <!-- Right: Feature List -->
                            <div class="platform-features">
                                <div class="feature-category">
                                    <div class="category-title">🤖 智能体能力</div>
                                    <div class="feature-list">
                                        <div class="feature-item">
                                            <div class="feature-icon">🎯</div>
                                            <div class="feature-text">
                                                <div class="feature-name">智能体中心</div>
                                                <div class="feature-desc">集中管理各类AI智能体应用</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">⚡</div>
                                            <div class="feature-text">
                                                <div class="feature-name">工作流中心</div>
                                                <div class="feature-desc">可视化编排业务流程</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">📚</div>
                                            <div class="feature-text">
                                                <div class="feature-name">知识库</div>
                                                <div class="feature-desc">企业知识统一管理与应用</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">💬</div>
                                            <div class="feature-text">
                                                <div class="feature-name">提示词库</div>
                                                <div class="feature-desc">标准化Prompt模板管理</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="feature-category">
                                    <div class="category-title">🔧 扩展与管理</div>
                                    <div class="feature-list">
                                        <div class="feature-item">
                                            <div class="feature-icon">🔌</div>
                                            <div class="feature-text">
                                                <div class="feature-name">插件库</div>
                                                <div class="feature-desc">丰富的功能插件生态</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">🎒</div>
                                            <div class="feature-text">
                                                <div class="feature-name">技能包</div>
                                                <div class="feature-desc">预置行业技能快速上手</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">📋</div>
                                            <div class="feature-text">
                                                <div class="feature-name">任务管理</div>
                                                <div class="feature-desc">AI任务调度与监控</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="feature-category">
                                    <div class="category-title">🏢 组织与集成</div>
                                    <div class="feature-list">
                                        <div class="feature-item">
                                            <div class="feature-icon">👥</div>
                                            <div class="feature-text">
                                                <div class="feature-name">组织架构</div>
                                                <div class="feature-desc">企业部门与人员管理</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">🔐</div>
                                            <div class="feature-text">
                                                <div class="feature-name">权限管理</div>
                                                <div class="feature-desc">细粒度访问控制</div>
                                            </div>
                                        </div>
                                        <div class="feature-item">
                                            <div class="feature-icon">🔗</div>
                                            <div class="feature-text">
                                                <div class="feature-name">第三方集成</div>
                                                <div class="feature-desc">无缝对接企业现有系统</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-show="false">
                    <!-- ═══════════ Slide 5: Architecture Diagram ═══════════ -->
                    <div class="slide slide-architecture" data-index="4">
                        <div class="container">
                            <div class="architecture-header">
                                <h1 class="architecture-title">智能体平台架构</h1>
                                <p class="architecture-subtitle">企业级AI智能体执行平台技术架构全景</p>
                            </div>

                            <div class="architecture-content">
                                <div class="architecture-diagram">
                                    <img :src="require('./image/architecture-diagram.png')" alt="智能体平台架构图"
                                        class="architecture-img">
                                </div>

                                <div class="architecture-legend">
                                    <div class="legend-title">架构分层说明</div>
                                    <div class="legend-items">
                                        <div class="legend-item">
                                            <div class="legend-color" style="background: #e0f2fe;"></div>
                                            <div class="legend-text">
                                                <strong>企业龙虾</strong>：对话型意图识别调用工具完成任务
                                            </div>
                                        </div>
                                        <div class="legend-item">
                                            <div class="legend-color" style="background: #dcfce7;"></div>
                                            <div class="legend-text">
                                                <strong>智能体</strong>：闭环应用型逻辑顺序调用工具完成任务
                                            </div>
                                        </div>
                                        <div class="legend-item">
                                            <div class="legend-color" style="background: #dbeafe;"></div>
                                            <div class="legend-text">
                                                <strong>开放能力</strong>：内部系统调用智能体工具集，实现数据互通
                                            </div>
                                        </div>
                                    </div>

                                    <div class="architecture-highlights">
                                        <div class="highlight-title">核心能力</div>
                                        <div class="highlight-list">
                                            <div class="highlight-item">🔁 闭环优化与知识归档</div>
                                            <div class="highlight-item">🧠 多Agent引擎协同</div>
                                            <div class="highlight-item">📊 向量数据库支持</div>
                                            <div class="highlight-item">🔐 安全治理与权限管控</div>
                                            <div class="highlight-item">☁️ 云端/本地大模型支持</div>
                                            <div class="highlight-item">🔌 丰富的插件与技能生态</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 6: Enterprise Claw Core Advantages ═══════════ -->
                <div class="slide slide-claw" data-index="6">
                    <div class="container">
                        <div class="claw-header">
                            <h1 class="claw-title">企业Claw 核心优势</h1>
                            <p class="claw-subtitle">不只是Agent，更是企业级的执行引擎</p>
                        </div>

                        <div class="claw-content">
                            <!-- Left Column: Architecture + Security + Memory -->
                            <div class="claw-left-column">
                                <!-- Advantage 1: Five-Layer Architecture -->
                                <div class="claw-card claw-card-flow">
                                    <div class="claw-card-header">
                                        <div class="claw-icon"
                                            style="background: linear-gradient(135deg, #3b82f6, #8b5cf6);">📐</div>
                                        <div class="claw-card-title">五层统一执行架构</div>
                                    </div>
                                    <div class="claw-card-desc">
                                        从用户请求到结果输出的全链路闭环管理，实现精准识别、智能路由、动态决策、统一调度、专业输出
                                    </div>
                                    <div class="claw-flow-wrapper">
                                        <div class="claw-flow-main">
                                            <div class="flow-step-wrapper first-step">
                                                <div class="flow-step" id="step1">① 能力发现</div>
                                            </div>
                                            <div class="flow-arrow">→</div>
                                            <div class="flow-step">② 能力解析</div>
                                            <div class="flow-arrow">→</div>
                                            <div class="flow-step">③ 执行决策</div>
                                            <div class="flow-arrow">→</div>
                                            <div class="flow-step">④ 工具执行</div>
                                        </div>
                                        <div class="claw-flow-branch">
                                            <div class="flow-branch-line">
                                                <div class="branch-arrow down">↓</div>
                                            </div>
                                            <div class="flow-branch-options">
                                                <div class="branch-option">
                                                    <div class="flow-step step-clarify">⑤ 澄清问题</div>
                                                    <div class="branch-desc">参数缺失/不明确时</div>
                                                    <div class="claw-loop-back">
                                                        <div class="loop-arrow">↺</div>
                                                        <div class="loop-text">回到①重新理解</div>
                                                    </div>
                                                </div>
                                                <div class="branch-option">
                                                    <div class="flow-step step-output">⑤ 结果输出</div>
                                                    <div class="branch-desc">执行完成/成功时</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Advantage 2: Security -->
                                <div class="claw-card">
                                    <div class="claw-card-header">
                                        <div class="claw-icon"
                                            style="background: linear-gradient(135deg, #ef4444, #f59e0b);">🛡️</div>
                                        <div class="claw-card-title">四层纵深安全防御</div>
                                    </div>
                                    <div class="claw-card-desc">
                                        相比开源方案的安全漏洞频发，企业级四层全周期安全防护，确保数据与执行安全
                                    </div>
                                    <div class="claw-security-layers">
                                        <div class="sec-layer layer-input">
                                            <div class="sec-icon">🔒</div>
                                            <div class="sec-name">输入验证</div>
                                        </div>
                                        <div class="sec-layer layer-ai">
                                            <div class="sec-icon">🤖</div>
                                            <div class="sec-name">AI决策安全</div>
                                        </div>
                                        <div class="sec-layer layer-sandbox">
                                            <div class="sec-icon">🏰</div>
                                            <div class="sec-name">执行沙箱</div>
                                        </div>
                                        <div class="sec-layer layer-output">
                                            <div class="sec-icon">🛡️</div>
                                            <div class="sec-name">输出过滤</div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Advantage 4: Memory System -->
                                <div class="claw-card">
                                    <div class="claw-card-header">
                                        <div class="claw-icon"
                                            style="background: linear-gradient(135deg, #22c55e, #06b6d4, #f59e0b);">🧠
                                        </div>
                                        <div class="claw-card-title">三层记忆系统</div>
                                    </div>
                                    <div class="claw-card-desc">
                                        上下文一致性保障，跨会话持久化，个性化体验一致，实时同步执行状态
                                    </div>
                                    <div class="claw-memory-layers">
                                        <div class="mem-layer mem-long">
                                            <div class="mem-badge">长期</div>
                                            <div class="mem-content">
                                                <div class="mem-title">Long-Term Memory</div>
                                                <div class="mem-tags">
                                                    <span>用户身份</span>
                                                    <span>偏好设置</span>
                                                    <span>行为模式</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mem-layer mem-medium">
                                            <div class="mem-badge">中期</div>
                                            <div class="mem-content">
                                                <div class="mem-title">Medium-Term Memory</div>
                                                <div class="mem-tags">
                                                    <span>会话摘要</span>
                                                    <span>近期上下文</span>
                                                    <span>任务状态</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="mem-layer mem-short">
                                            <div class="mem-badge">短期</div>
                                            <div class="mem-content">
                                                <div class="mem-title">Short-Term Memory</div>
                                                <div class="mem-tags">
                                                    <span>对话历史</span>
                                                    <span>执行状态</span>
                                                    <span>事件流</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Right Column: Fault Tolerance (Full Height) -->
                            <div class="claw-right-column">
                                <!-- Advantage 3: Fault Tolerance -->
                                <div class="claw-card">
                                    <div class="claw-card-header">
                                        <div class="claw-icon"
                                            style="background: linear-gradient(135deg, #22c55e, #3b82f6);">🎯</div>
                                        <div class="claw-card-title">任务执行一致性保障</div>
                                    </div>
                                    <div class="claw-card-desc">
                                        智能容错与恢复机制，对话状态机管理 + 三层记忆系统，确保任务执行的稳定性与连续性
                                    </div>
                                    <div class="claw-fault-features">
                                        <div class="fault-feature">
                                            <div class="fault-icon">🔄</div>
                                            <div class="fault-text">
                                                <div class="fault-name">自动重试</div>
                                                <div class="fault-detail">失败自动重试，智能降级</div>
                                            </div>
                                        </div>
                                        <div class="fault-feature">
                                            <div class="fault-icon">💾</div>
                                            <div class="fault-text">
                                                <div class="fault-name">状态恢复</div>
                                                <div class="fault-detail">断点续传，异常恢复</div>
                                            </div>
                                        </div>
                                        <div class="fault-feature">
                                            <div class="fault-icon">🧠</div>
                                            <div class="fault-text">
                                                <div class="fault-name">三层记忆</div>
                                                <div class="fault-detail">长/中/短期记忆协同</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 工作流编排能力 -->
                                    <div class="workflow-section"
                                        style="margin-top: 16px; padding-top: 16px; border-top: 1px dashed rgba(255,255,255,0.1);">
                                        <div
                                            style="font-size: 0.8rem; color: #94a3b8; margin-bottom: 12px; font-weight: 600;">
                                            🔗 工作流编排能力</div>
                                        <div class="node-grid"
                                            style="display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; margin-bottom: 12px;">
                                            <div class="node-card"
                                                style="background: rgba(59,130,246,0.1); border: 1px solid rgba(59,130,246,0.3); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.7rem; color: #60a5fa; font-weight: 600;">🤖
                                                    大模型/工作流</div>
                                            </div>
                                            <div class="node-card"
                                                style="background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.3); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.7rem; color: #f59e0b; font-weight: 600;">🔄
                                                    业务逻辑循环</div>
                                            </div>
                                            <div class="node-card"
                                                style="background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.3); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.7rem; color: #10b981; font-weight: 600;">📥 输入
                                                    & 输出</div>
                                            </div>
                                            <div class="node-card"
                                                style="background: rgba(239,68,68,0.1); border: 1px solid rgba(239,68,68,0.3); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.7rem; color: #ef4444; font-weight: 600;">🗄️
                                                    数据库操作</div>
                                            </div>
                                            <div class="node-card"
                                                style="background: rgba(139,92,246,0.1); border: 1px solid rgba(139,92,246,0.3); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.7rem; color: #8b5cf6; font-weight: 600;">📚 知识库
                                                    & 数据</div>
                                            </div>
                                            <div class="node-card"
                                                style="background: rgba(6,182,212,0.1); border: 1px solid rgba(6,182,212,0.3); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.7rem; color: #06b6d4; font-weight: 600;">🧩
                                                    组件工具</div>
                                            </div>
                                        </div>
                                        <div class="guarantee-row"
                                            style="display: flex; gap: 8px; justify-content: center;">
                                            <div class="guarantee-item"
                                                style="flex: 1; background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.2); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.9rem; margin-bottom: 4px;">🎯</div>
                                                <div style="font-size: 0.7rem; color: #f59e0b; font-weight: 600;">一致性保证
                                                </div>
                                                <div style="font-size: 0.6rem; color: #94a3b8;">Gate节点校验上下文衔接</div>
                                            </div>
                                            <div class="guarantee-item"
                                                style="flex: 1; background: rgba(139,92,246,0.1); border: 1px solid rgba(139,92,246,0.2); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.9rem; margin-bottom: 4px;">✅</div>
                                                <div style="font-size: 0.7rem; color: #8b5cf6; font-weight: 600;">准确性保证
                                                </div>
                                                <div style="font-size: 0.6rem; color: #94a3b8;">结果校验拦截错误</div>
                                            </div>
                                            <div class="guarantee-item"
                                                style="flex: 1; background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.2); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div style="font-size: 0.9rem; margin-bottom: 4px;">🔒</div>
                                                <div style="font-size: 0.7rem; color: #10b981; font-weight: 600;">可靠性保证
                                                </div>
                                                <div style="font-size: 0.6rem; color: #94a3b8;">类型强校验安全防线</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Skill执行流程 -->
                                    <div class="skill-section"
                                        style="margin-top: 16px; padding-top: 16px; border-top: 1px dashed rgba(255,255,255,0.1);">
                                        <div
                                            style="font-size: 0.8rem; color: #94a3b8; margin-bottom: 12px; font-weight: 600;">
                                            ⚡ Skill执行流程：AI自主决策闭环</div>
                                        <div class="skill-flow"
                                            style="display: flex; align-items: center; justify-content: center; gap: 4px; flex-wrap: wrap;">
                                            <div class="skill-step"
                                                style="background: linear-gradient(135deg, #3b82f6, #6366f1); color: white; padding: 6px 10px; border-radius: 6px; font-size: 0.7rem; font-weight: 600; text-align: center;">
                                                <div>① 解析</div>
                                                <div style="font-size: 0.6rem; opacity: 0.9;">SkillDocParser</div>
                                            </div>
                                            <div style="color: #94a3b8;">→</div>
                                            <div class="skill-step"
                                                style="background: linear-gradient(135deg, #8b5cf6, #a855f7); color: white; padding: 6px 10px; border-radius: 6px; font-size: 0.7rem; font-weight: 600; text-align: center;">
                                                <div>② 规划</div>
                                                <div style="font-size: 0.6rem; opacity: 0.9;">ExecutionPlanner</div>
                                            </div>
                                            <div style="color: #94a3b8;">→</div>
                                            <div class="skill-step"
                                                style="background: linear-gradient(135deg, #10b981, #22c55e); color: white; padding: 6px 10px; border-radius: 6px; font-size: 0.7rem; font-weight: 600; text-align: center;">
                                                <div>③ 执行</div>
                                                <div style="font-size: 0.6rem; opacity: 0.9;">ToolExecutor</div>
                                            </div>
                                            <div style="color: #94a3b8;">→</div>
                                            <div class="skill-step"
                                                style="background: linear-gradient(135deg, #f59e0b, #f97316); color: white; padding: 6px 10px; border-radius: 6px; font-size: 0.7rem; font-weight: 600; text-align: center;">
                                                <div>④ 后处理</div>
                                                <div style="font-size: 0.6rem; opacity: 0.9;">ResultProcessor</div>
                                            </div>
                                        </div>
                                        <div class="skill-modes"
                                            style="display: flex; gap: 8px; margin-top: 12px; justify-content: center;">
                                            <div
                                                style="flex: 1; background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.2); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div
                                                    style="font-size: 0.65rem; color: #f59e0b; font-weight: 600; margin-bottom: 4px;">
                                                    🏎️ 4种执行模式</div>
                                                <div style="font-size: 0.6rem; color: #94a3b8; line-height: 1.4;">内置工具 ·
                                                    Shell脚本<br>直接响应 · AI动态生成</div>
                                            </div>
                                            <div
                                                style="flex: 1; background: rgba(139,92,246,0.1); border: 1px solid rgba(139,92,246,0.2); border-radius: 6px; padding: 8px; text-align: center;">
                                                <div
                                                    style="font-size: 0.65rem; color: #8b5cf6; font-weight: 600; margin-bottom: 4px;">
                                                    📊 3种并行策略</div>
                                                <div style="font-size: 0.6rem; color: #94a3b8; line-height: 1.4;">顺序执行 ·
                                                    并行执行<br>条件执行</div>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 知识库引擎 -->
                                    <div class="knowledge-section"
                                        style="margin-top: 16px; padding-top: 16px; border-top: 1px dashed rgba(255,255,255,0.1);">
                                        <div
                                            style="font-size: 0.8rem; color: #94a3b8; margin-bottom: 12px; font-weight: 600;">
                                            🧠 知识库引擎 — Knowledge Engine</div>
                                        <div class="knowledge-grid"
                                            style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; margin-bottom: 12px;">
                                            <div class="knowledge-card"
                                                style="background: rgba(6,182,212,0.1); border: 1px solid rgba(6,182,212,0.3); border-radius: 6px; padding: 8px;">
                                                <div
                                                    style="font-size: 0.7rem; color: #06b6d4; font-weight: 600; margin-bottom: 4px;">
                                                    📄 文档处理</div>
                                                <div style="font-size: 0.6rem; color: #94a3b8; line-height: 1.4;">
                                                    PDF/Word/Markdown解析<br>智能分块 · 元数据提取</div>
                                            </div>
                                            <div class="knowledge-card"
                                                style="background: rgba(59,130,246,0.1); border: 1px solid rgba(59,130,246,0.3); border-radius: 6px; padding: 8px;">
                                                <div
                                                    style="font-size: 0.7rem; color: #60a5fa; font-weight: 600; margin-bottom: 4px;">
                                                    🔢 向量化</div>
                                                <div style="font-size: 0.6rem; color: #94a3b8; line-height: 1.4;">
                                                    Embedding模型适配<br>向量索引 · 增量更新</div>
                                            </div>
                                            <div class="knowledge-card"
                                                style="background: rgba(16,185,129,0.1); border: 1px solid rgba(16,185,129,0.3); border-radius: 6px; padding: 8px;">
                                                <div
                                                    style="font-size: 0.7rem; color: #10b981; font-weight: 600; margin-bottom: 4px;">
                                                    🔍 检索引擎</div>
                                                <div style="font-size: 0.6rem; color: #94a3b8; line-height: 1.4;">
                                                    语义+关键词混合检索<br>重排序 · MMR去重</div>
                                            </div>
                                            <div class="knowledge-card"
                                                style="background: rgba(245,158,11,0.1); border: 1px solid rgba(245,158,11,0.3); border-radius: 6px; padding: 8px;">
                                                <div
                                                    style="font-size: 0.7rem; color: #f59e0b; font-weight: 600; margin-bottom: 4px;">
                                                    📚 知识管理</div>
                                                <div style="font-size: 0.6rem; color: #94a3b8; line-height: 1.4;">知识图谱 ·
                                                    标签体系<br>版本管理 · 权限控制</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div class="claw-summary">
                            <div class="claw-summary-text">
                                企业级安全 · 任务一致性 · 智能容错 · 上下文记忆<br>
                                <strong>构建可靠、安全、智能的企业AI执行引擎</strong>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 7: Agent Paradigms ═══════════ -->
                <div class="slide slide-paradigms" data-index="7">
                    <div class="container">
                        <div class="paradigm-header">
                            <h1 class="paradigm-title">智能体的两大范式</h1>
                            <p class="paradigm-subtitle">面向不同任务确定性与复杂度，企业智能体通常落在 Skill Agent 与工作流编排两种实现范式</p>
                        </div>

                        <div class="paradigm-grid">
                            <div class="paradigm-card skill">
                                <div class="paradigm-card-header">
                                    <div>
                                        <div class="paradigm-badge">范式一</div>
                                        <div class="paradigm-card-title">Skill Agent</div>
                                        <div class="paradigm-card-desc">
                                            以大模型为决策中枢，围绕用户目标自主选择技能、组合工具并动态推进任务，更适合开放式、变化多的非确定性任务。</div>
                                    </div>
                                    <div class="paradigm-icon">⚡</div>
                                </div>

                                <div class="paradigm-section">
                                    <div class="paradigm-section-title">典型执行方式</div>
                                    <div class="paradigm-flow">
                                        <span class="paradigm-step">理解意图</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">自主规划</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">选择 Skill</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">动态执行</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">结果交付</span>
                                    </div>
                                </div>

                                <div class="paradigm-section">
                                    <div class="paradigm-section-title">适用场景</div>
                                    <div class="paradigm-list">
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>开放式任务</strong>：问题不完全标准化，需要根据上下文实时判断。</span>
                                        </div>
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>工具选择不固定</strong>：不同任务需按需调用搜索、文件、知识库、系统接口等技能。</span>
                                        </div>
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>强调交互体验</strong>：需要边执行边解释，支持澄清、追问与过程透明化展示。</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="paradigm-section">
                                    <div class="paradigm-section-title">核心优势</div>
                                    <div class="paradigm-list">
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>灵活性强</strong>：面对长尾问题和变化任务更容易泛化。</span>
                                        </div>
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>接近人类协作</strong>：更像一位会思考、会调用工具的数字员工。</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="paradigm-card workflow">
                                <div class="paradigm-card-header">
                                    <div>
                                        <div class="paradigm-badge">范式二</div>
                                        <div class="paradigm-card-title">工作流编排</div>
                                        <div class="paradigm-card-desc">
                                            将任务拆解为显式节点、规则与依赖关系，通过可视化方式定义流程，更适合步骤稳定、结果要求可控的确定性业务流程。</div>
                                    </div>
                                    <div class="paradigm-icon">🔗</div>
                                </div>

                                <div class="paradigm-section">
                                    <div class="paradigm-section-title">典型执行方式</div>
                                    <div class="paradigm-flow">
                                        <span class="paradigm-step">定义节点</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">设置分支</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">串并行编排</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">流程执行</span>
                                        <span class="paradigm-arrow">→</span>
                                        <span class="paradigm-step">校验输出</span>
                                    </div>
                                </div>

                                <div class="paradigm-section">
                                    <div class="paradigm-section-title">适用场景</div>
                                    <div class="paradigm-list">
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>标准化流程</strong>：如审批、审核、抽取、报告生成等固定步骤任务。</span>
                                        </div>
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>强调稳定与可控</strong>：需要明确依赖关系、状态流转、异常处理和结果校验。</span>
                                        </div>
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>强调系统集成</strong>：适合连接企业内部系统、数据库、接口与消息流。</span>
                                        </div>
                                    </div>
                                </div>

                                <div class="paradigm-section">
                                    <div class="paradigm-section-title">核心优势</div>
                                    <div class="paradigm-list">
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>确定性更高</strong>：流程可配置、可追踪、可审计，适合正式生产场景。</span>
                                        </div>
                                        <div class="paradigm-item"><span
                                                class="paradigm-dot"></span><span><strong>工程化更强</strong>：更容易做监控、重试、并发控制与权限治理。</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="paradigm-summary">
                            <strong>选择原则：</strong>开放任务、依赖模型自主决策时优先使用 <strong>Skill Agent</strong>；流程固定、强调稳定交付与系统协同时优先使用
                            <strong>工作流编排</strong>。两者并不是替代关系，而是企业智能体建设中的互补范式。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 8: Skill Agent Showcase ═══════════ -->
                <div class="slide slide-agent-showcase" data-index="8">
                    <div class="container">
                        <div class="agent-showcase-header">
                            <h1 class="agent-showcase-title">范式1：Skill Agent 能力展示</h1>
                            <p class="agent-showcase-subtitle">以大模型自主决策为核心，通过技能动态选择、过程透明执行与结果交付，完成开放式任务处理</p>
                        </div>

                        <div class="agent-showcase-pillars">
                            <div class="agent-pillar">
                                <div class="agent-pillar-title">执行过程可视</div>
                                <div class="agent-pillar-desc">将任务拆解、工具调用、执行状态实时呈现，让用户清楚看到智能体“怎么做”。</div>
                            </div>
                            <div class="agent-pillar">
                                <div class="agent-pillar-title">技能协同执行</div>
                                <div class="agent-pillar-desc">围绕具体任务按需调用文件读取、搜索、执行等能力，形成面向目标的多步骤协作。</div>
                            </div>
                            <div class="agent-pillar">
                                <div class="agent-pillar-title">结果交付清晰</div>
                                <div class="agent-pillar-desc">输出不仅给出最终答案，还沉淀为结构化结果与过程记录，便于复核、复用与复盘。</div>
                            </div>
                        </div>

                        <div class="agent-showcase-grid">
                            <div class="agent-showcase-card">
                                <div class="agent-showcase-body">
                                    <div class="agent-showcase-label">自主理解</div>
                                    <div class="agent-showcase-card-title">基于问题上下文完成能力判断与任务规划</div>
                                    <div class="agent-showcase-card-desc">当用户发起开放式问题时，Skill Agent
                                        会先理解意图，再结合技能体系、记忆和上下文信息判断应该采用什么执行路径，并解释自身为何能完成该任务。</div>
                                    <div class="agent-showcase-tags">
                                        <span class="agent-showcase-tag">意图理解</span>
                                        <span class="agent-showcase-tag">能力判断</span>
                                        <span class="agent-showcase-tag">任务规划</span>
                                    </div>
                                </div>
                                <div class="agent-showcase-image-wrap">
                                    <img :src="require('./image/agent-show-who.png')" alt="智能体能力说明展示"
                                        class="agent-showcase-image">
                                </div>
                            </div>

                            <div class="agent-showcase-card" style="margin-top: 30px;">
                                <div class="agent-showcase-body">
                                    <div class="agent-showcase-label">动态执行</div>
                                    <div class="agent-showcase-card-title">按目标动态调用多个 Skill 完成任务</div>
                                    <div class="agent-showcase-card-desc">面对明确任务目标，Skill Agent
                                        能够自主选择文件读取、检索、执行等多个技能，边执行边推进任务，并最终输出结构化结果，形成完整闭环。</div>
                                    <div class="agent-showcase-tags">
                                        <span class="agent-showcase-tag">Skill 调用</span>
                                        <span class="agent-showcase-tag">动态决策</span>
                                        <span class="agent-showcase-tag">结果交付</span>
                                    </div>
                                </div>
                                <div class="agent-showcase-image-wrap">
                                    <img :src="require('./image/agent-show-tool.png')" alt="多技能协同执行展示"
                                        class="agent-showcase-image">
                                </div>
                            </div>
                        </div>

                        <div class="agent-showcase-summary">
                            <strong>Skill Agent</strong> 的核心价值，在于让模型具备面向目标的自主决策能力: 先理解任务，再动态选择 Skill
                            并执行，从而更好地处理开放式、非确定性的复杂任务。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 9: Skill Intro ═══════════ -->
                <div class="slide slide-skill-intro" data-index="9">
                    <div class="container">
                        <div class="skill-intro-header">
                            <h1 class="skill-intro-title">Skill 是什么</h1>
                            <p class="skill-intro-subtitle">Skill 是智能体可调用的标准化能力单元，把复杂任务拆成可复用、可组合、可导入的执行能力</p>
                        </div>

                        <div class="skill-intro-pillars">
                            <div class="skill-intro-pillar">
                                <div class="skill-intro-pillar-title">能力单元化</div>
                                <div class="skill-intro-pillar-desc">把搜索、抓取、解析、写作、系统调用等能力封装成标准组件，供智能体按需调用。</div>
                            </div>
                            <div class="skill-intro-pillar">
                                <div class="skill-intro-pillar-title">来源多样化</div>
                                <div class="skill-intro-pillar-desc">Skill 可以来自 SkillHub 社区，也可以由企业根据自身场景直接编写并导入平台。</div>
                            </div>
                            <div class="skill-intro-pillar">
                                <div class="skill-intro-pillar-title">任务可复用</div>
                                <div class="skill-intro-pillar-desc">通过 Skill 的沉淀与复用，把个人经验转化为组织级能力资产，持续服务不同业务任务。</div>
                            </div>
                        </div>

                        <div class="skill-intro-content">
                            <div class="skill-intro-screenshot">
                                <img :src="require('./image/agent-skill.png')" alt="Skill 技能包列表"
                                    class="skill-intro-image">
                            </div>

                            <!-- <div class="skill-intro-right">
                                <div class="skill-intro-card">
                                    <div class="skill-intro-card-title">Skill 是智能体可调用的工具能力</div>
                                    <div class="skill-intro-card-desc">对于 Skill Agent 来说，Skill
                                        不是简单的插件列表，而是可被模型识别、选择和执行的能力模块。智能体会根据当前目标，自主决定调用哪一个 Skill 来完成具体步骤。</div>
                                </div>

                                <div class="skill-intro-card">
                                    <div class="skill-intro-card-title">Skill 的来源：社区共享 + 企业自建</div>
                                    <div class="skill-intro-card-desc">一方面，企业可以从 SkillHub 社区引入成熟
                                        Skill，快速获得通用能力；另一方面，也可以围绕企业内部系统、流程和 know-how 直接编写 Skill 并导入平台，沉淀专属能力。</div>
                                    <div class="skill-source-tags">
                                        <span class="skill-source-tag">SkillHub 社区</span>
                                        <span class="skill-source-tag">自定义编写</span>
                                        <span class="skill-source-tag">导入复用</span>
                                        <span class="skill-source-tag">企业专属能力</span>
                                    </div>
                                </div>

                                <div class="skill-intro-card">
                                    <div class="skill-intro-card-title">Skill 的作用：把任务能力资产化</div>
                                    <div class="skill-intro-card-desc">Skill
                                        的价值在于把一次性的操作经验、接口能力和业务动作标准化，让智能体能够稳定复用、自由组合，并在不同任务中持续调用，最终形成企业自己的能力库。</div>
                                    <div class="skill-effect-tags">
                                        <span class="skill-effect-tag">能力标准化</span>
                                        <span class="skill-effect-tag">灵活组合</span>
                                        <span class="skill-effect-tag">组织复用</span>
                                        <span class="skill-effect-tag">持续沉淀</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="skill-intro-summary">
                            <strong>Skill</strong> 解决的是“智能体用什么能力做事”的问题。它既是 Skill Agent 的执行基础，也是企业把业务能力、系统接口和 know-how
                            资产化的关键载体。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 10: Workflow Orchestration ═══════════ -->
                <div class="slide slide-workflow" data-index="10">
                    <div class="container">
                        <div class="workflow-header">
                            <h1 class="workflow-title">范式2：工作流编排</h1>
                            <p class="workflow-subtitle">通过可视化 DAG 编排固定流程、分支与节点依赖，适用于标准化、可控、可审计的企业业务执行场景</p>
                        </div>

                        <div class="workflow-content">
                            <div class="workflow-left">
                                <div class="workflow-screenshot">
                                    <img :src="require('./image/workflow-orchestration.png')" alt="工作流编排界面"
                                        class="workflow-img">
                                </div>
                                <!-- 编排能力 -->
                                <div class="workflow-capabilities">
                                    <div class="capability-card">
                                        <div class="capability-icon">📊</div>
                                        <div class="capability-title">DAG 编排</div>
                                        <div class="capability-desc">任务依赖 · 拓扑排序 · 条件分支 · 循环控制</div>
                                    </div>
                                    <div class="capability-card">
                                        <div class="capability-icon">⚡</div>
                                        <div class="capability-title">执行策略</div>
                                        <div class="capability-desc">并行执行 · 串行执行 · 重试机制 · 超时控制</div>
                                    </div>
                                    <div class="capability-card">
                                        <div class="capability-icon">💾</div>
                                        <div class="capability-title">状态管理</div>
                                        <div class="capability-desc">步骤输出缓存 · 上下文传递 · 断点续跑</div>
                                    </div>
                                    <div class="capability-card">
                                        <div class="capability-icon">🔍</div>
                                        <div class="capability-title">可观测性</div>
                                        <div class="capability-desc">执行追踪 · 耗时统计 · 日志采集</div>
                                    </div>
                                    <div class="capability-card">
                                        <div class="capability-icon">🛡️</div>
                                        <div class="capability-title">错误处理</div>
                                        <div class="capability-desc">异常捕获 · 降级策略 · 回滚机制</div>
                                    </div>
                                    <div class="capability-card">
                                        <div class="capability-icon">🔒</div>
                                        <div class="capability-title">安全控制</div>
                                        <div class="capability-desc">权限校验 · 沙箱隔离 · 资源限制</div>
                                    </div>
                                </div>
                            </div>

                            <!-- <div class="workflow-nodes">
                                <div class="workflow-category">
                                    <div class="workflow-category-title">🤖 大模型 / 工作流 / 插件节点</div>
                                    <div class="workflow-category-desc">核心能力节点，支持 AI 推理、子工作流调用和外部插件执行</div>
                                    <div class="workflow-tags">
                                        <span class="workflow-tag blue">LLM 大模型</span>
                                        <span class="workflow-tag purple">工作流调用</span>
                                        <span class="workflow-tag orange">插件执行</span>
                                    </div>
                                </div>

                                <div class="workflow-category">
                                    <div class="workflow-category-title">🔄 业务逻辑循环节点</div>
                                    <div class="workflow-category-desc">流程控制节点，实现循环、条件判断、变量聚合等逻辑</div>
                                    <div class="workflow-tags">
                                        <span class="workflow-tag orange">批处理</span>
                                        <span class="workflow-tag blue">意图识别</span>
                                        <span class="workflow-tag green">变量聚合</span>
                                        <span class="workflow-tag purple">代码</span>
                                        <span class="workflow-tag cyan">选择器</span>
                                    </div>
                                </div>

                                <div class="workflow-category">
                                    <div class="workflow-category-title">📥 输入 & 输出节点</div>
                                    <div class="workflow-category-desc">数据流转节点，定义工作流的输入参数和输出结果</div>
                                    <div class="workflow-tags">
                                        <span class="workflow-tag green">输入节点</span>
                                        <span class="workflow-tag green">输出节点</span>
                                    </div>
                                </div>

                                <div class="workflow-category">
                                    <div class="workflow-category-title">🗄️ 数据库节点</div>
                                    <div class="workflow-category-desc">数据操作节点，支持增删改查和自定义 SQL 执行</div>
                                    <div class="workflow-tags">
                                        <span class="workflow-tag red">查询数据</span>
                                        <span class="workflow-tag red">删除数据</span>
                                        <span class="workflow-tag red">SQL 自定义</span>
                                        <span class="workflow-tag red">更新数据</span>
                                    </div>
                                </div>

                                <div class="workflow-category">
                                    <div class="workflow-category-title">📚 知识库 & 数据节点</div>
                                    <div class="workflow-category-desc">知识处理节点，支持知识库检索、写入和变量赋值</div>
                                    <div class="workflow-tags">
                                        <span class="workflow-tag purple">知识库检索</span>
                                        <span class="workflow-tag purple">知识库写入</span>
                                        <span class="workflow-tag cyan">变量赋值</span>
                                    </div>
                                </div>

                                <div class="workflow-category">
                                    <div class="workflow-category-title">🧩 组件节点</div>
                                    <div class="workflow-category-desc">通用组件节点，提供 HTTP 请求、JSON 处理、文本处理等能力</div>
                                    <div class="workflow-tags">
                                        <span class="workflow-tag cyan">HTTP 请求</span>
                                        <span class="workflow-tag cyan">JSON 序列化</span>
                                        <span class="workflow-tag blue">问答</span>
                                        <span class="workflow-tag orange">文本处理</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 11: Plugin Intro ═══════════ -->
                <div class="slide slide-plugin-intro" data-index="11">
                    <div class="container">
                        <div class="plugin-intro-header">
                            <h1 class="plugin-intro-title">插件：连接其他系统的能力桥梁</h1>
                            <p class="plugin-intro-subtitle">插件为工作流提供标准化系统连接能力，让 AI 不只停留在推理与编排，还能真正打通企业内外部系统完成业务动作</p>
                        </div>

                        <div class="plugin-pillars">
                            <div class="plugin-pillar">
                                <div class="plugin-pillar-title">系统连接</div>
                                <div class="plugin-pillar-desc">通过插件把企业微信、OA、CRM、文档系统、第三方 API 等外部能力接入工作流。</div>
                            </div>
                            <div class="plugin-pillar">
                                <div class="plugin-pillar-title">能力暴露</div>
                                <div class="plugin-pillar-desc">将接口方法、服务能力与业务动作封装成标准工具，供工作流节点按需调用。</div>
                            </div>
                            <div class="plugin-pillar">
                                <div class="plugin-pillar-title">业务执行</div>
                                <div class="plugin-pillar-desc">让工作流具备真正对外执行的能力，从信息查询延伸到消息发送、文档创建、会议管理等动作。</div>
                            </div>
                        </div>

                        <div class="plugin-intro-content">
                            <div class="plugin-intro-screenshot">
                                <img :src="require('./image/agent-plugin.png')" alt="插件能力与接口列表"
                                    class="plugin-intro-image">
                            </div>

                            <!-- <div class="plugin-intro-right">
                                <div class="plugin-intro-card">
                                    <div class="plugin-intro-card-title">插件是什么</div>
                                    <div class="plugin-intro-card-desc">
                                        插件是面向系统能力的标准接入方式，用来把外部系统、内部接口和已有服务包装成工作流可直接调用的能力单元。它本质上解决的是“流程如何连到真实系统”的问题。
                                    </div>
                                </div>

                                <div class="plugin-intro-card">
                                    <div class="plugin-intro-card-title">插件的作用</div>
                                    <div class="plugin-intro-card-desc">
                                        在工作流编排中，插件负责把模型决策和系统执行衔接起来。工作流通过插件可以查询数据、调用接口、写入结果、触发业务动作，让流程真正进入企业执行链路。</div>
                                    <div class="plugin-tags">
                                        <span class="plugin-tag">接口调用</span>
                                        <span class="plugin-tag">系统打通</span>
                                        <span class="plugin-tag">数据交互</span>
                                        <span class="plugin-tag">业务触发</span>
                                    </div>
                                </div>

                                <div class="plugin-intro-card">
                                    <div class="plugin-intro-card-title">为什么工作流需要插件</div>
                                    <div class="plugin-intro-card-desc">
                                        如果没有插件，工作流只能停留在逻辑编排层；有了插件，工作流才能连接真实系统，完成消息发送、文档生成、会议管理、客户查询等动作，成为真正可落地的业务流程执行引擎。
                                    </div>
                                    <div class="plugin-tags">
                                        <span class="plugin-tag">连接外部系统</span>
                                        <span class="plugin-tag">扩展节点能力</span>
                                        <span class="plugin-tag">流程落地执行</span>
                                        <span class="plugin-tag">企业集成底座</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="plugin-intro-summary">
                            <strong>插件</strong> 解决的是“工作流如何连接其他系统并真正执行”的问题。它让工作流从内部逻辑编排，延伸为可调用接口、可联动系统、可触发业务动作的企业执行能力。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 12: Knowledge Base Showcase ═══════════ -->
                <div class="slide slide-kb-showcase" data-index="12">
                    <div class="container">
                        <div class="kb-showcase-header">
                            <h1 class="kb-showcase-title">知识库：企业内部数据资产</h1>
                            <p class="kb-showcase-subtitle">将企业制度、项目经验、专业规范与业务资料沉淀为可检索、可复用的知识资产，让 AI 真正理解企业内部 know-how
                            </p>
                        </div>

                        <div class="kb-pillars">
                            <div class="kb-pillar">
                                <div class="kb-pillar-title">资产沉淀</div>
                                <div class="kb-pillar-desc">把分散在文档、资料库、制度文件与项目经验中的知识，统一沉淀为企业可运营的数据资产。</div>
                            </div>
                            <div class="kb-pillar">
                                <div class="kb-pillar-title">知识检索</div>
                                <div class="kb-pillar-desc">通过语义检索与结构化组织，让 AI 能够快速找到与当前任务最相关的内部知识内容。</div>
                            </div>
                            <div class="kb-pillar">
                                <div class="kb-pillar-title">经验传承</div>
                                <div class="kb-pillar-desc">将企业内部 know-how 转化为可调用的知识能力，减少经验依赖个人、提升组织复用效率。</div>
                            </div>
                        </div>

                        <div class="kb-showcase-grid">
                            <div class="kb-card">
                                <div class="kb-card-body">
                                    <div class="kb-label">知识资产</div>
                                    <div class="kb-card-title">统一沉淀企业内部知识库</div>
                                    <div class="kb-card-desc">面向企业内部资料、制度规范、行业标准与项目经验建立统一知识库，把原本分散的数据内容转化为 AI
                                        可理解、可检索、可复用的企业知识资产。</div>
                                    <div class="kb-tags">
                                        <span class="kb-tag">内部资料沉淀</span>
                                        <span class="kb-tag">知识资产化</span>
                                        <span class="kb-tag">统一管理</span>
                                    </div>
                                </div>
                                <div class="kb-image-wrap">
                                    <img :src="require('./image/agent-kb.png')" alt="企业知识库列表" class="kb-image">
                                </div>
                            </div>

                            <div class="kb-card" style="margin-top: 30px;">
                                <div class="kb-card-body">
                                    <div class="kb-label">知识问答</div>
                                    <div class="kb-card-title">让 AI 理解并调用企业内部 know-how</div>
                                    <div class="kb-card-desc">基于企业知识库进行问答与解释，AI
                                        不再只依赖通用模型知识，而是能够结合企业自己的方案、规范和经验，给出更贴近业务语境的回答。</div>
                                    <div class="kb-tags">
                                        <span class="kb-tag">语义检索</span>
                                        <span class="kb-tag">知识增强问答</span>
                                        <span class="kb-tag">业务经验复用</span>
                                    </div>
                                </div>
                                <div class="kb-image-wrap">
                                    <img :src="require('./image/agent-kb-chat.png')" alt="基于知识库的问答交互" class="kb-image">
                                </div>
                            </div>
                        </div>

                        <div class="kb-summary">
                            <strong>知识库</strong> 本质上是企业内部的数据资产底座，它让 AI 从“知道通用常识”升级为“理解企业
                            know-how”，从而输出更准确、更贴近业务、更可复用的结果。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 13: Agent Center ═══════════ -->
                <div class="slide slide-agent-center" data-index="13">
                    <div class="container">
                        <div class="agent-center-header">
                            <h1 class="agent-center-title">智能体中心</h1>
                            <p class="agent-center-subtitle">统一智能体应用入口，支持多种交互模式满足不同业务场景</p>
                        </div>

                        <div class="agent-center-content">
                            <!-- 对话型应用 -->
                            <div class="agent-mode-card">
                                <div class="agent-mode-header">
                                    <div class="agent-mode-icon">💬</div>
                                    <div class="agent-mode-title">对话型应用</div>
                                </div>
                                <div class="agent-mode-desc">
                                    基于自然语言的交互方式，用户通过对话与智能体进行实时交流。适用于问答、咨询、内容生成等场景，支持多轮对话上下文理解。
                                </div>
                                <div class="agent-mode-features">
                                    <span class="agent-mode-tag">自然语言交互</span>
                                    <span class="agent-mode-tag">多轮对话</span>
                                    <span class="agent-mode-tag">实时响应</span>
                                    <span class="agent-mode-tag">上下文理解</span>
                                </div>
                                <div class="agent-mode-screenshot">
                                    <img :src="require('./image/agent-center-chat.png')" alt="对话型应用"
                                        class="agent-mode-img">
                                </div>
                            </div>

                            <!-- 集成型交互型应用 -->
                            <div class="agent-mode-card" style="margin-top: 30px;">
                                <div class="agent-mode-header">
                                    <div class="agent-mode-icon">🎯</div>
                                    <div class="agent-mode-title">集成型交互应用</div>
                                </div>
                                <div class="agent-mode-desc">
                                    深度集成业务流程的交互界面，支持文件上传、表单填写、流程审批等复杂操作。适用于标书处理、文档审核、数据分析等专业场景。
                                </div>
                                <div class="agent-mode-features">
                                    <span class="agent-mode-tag">文件处理</span>
                                    <span class="agent-mode-tag">流程集成</span>
                                    <span class="agent-mode-tag">历史记录</span>
                                    <span class="agent-mode-tag">业务闭环</span>
                                </div>
                                <div class="agent-mode-screenshot">
                                    <img :src="require('./image/agent-center-integrated.png')" alt="集成型交互应用"
                                        class="agent-mode-img">
                                </div>
                            </div>
                        </div>

                        <!-- 智能体中心管理能力 -->
                        <div class="agent-center-management">
                            <div class="management-card">
                                <div class="management-icon">📂</div>
                                <div class="management-content">
                                    <div class="management-title">智能体分类管理</div>
                                    <div class="management-desc">支持按业务场景、部门、功能类型等多维度分类，便于用户快速定位所需智能体</div>
                                    <div class="management-tags">
                                        <span class="management-tag">多级分类</span>
                                        <span class="management-tag">标签体系</span>
                                        <span class="management-tag">智能推荐</span>
                                    </div>
                                </div>
                            </div>
                            <div class="management-card">
                                <div class="management-icon">🔐</div>
                                <div class="management-content">
                                    <div class="management-title">可见范围权限设置</div>
                                    <div class="management-desc">细粒度权限控制，支持按部门、个人设置智能体的可见性和使用权限</div>
                                    <div class="management-tags">
                                        <span class="management-tag">部门隔离</span>
                                        <span class="management-tag">授权管理</span>
                                        <span class="management-tag">公开/私有</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 14: Agent Orchestration ═══════════ -->
                <div class="slide slide-orchestration" data-index="14">
                    <div class="container">
                        <div class="orchestration-header">
                            <h1 class="orchestration-title">智能体编排</h1>
                            <p class="orchestration-subtitle">可视化智能体构建平台，零代码实现复杂AI应用编排</p>
                        </div>

                        <div class="orchestration-content">
                            <div class="orchestration-screenshot">
                                <img :src="require('./image/agent-orchestration.png')" alt="智能体编排平台"
                                    class="orchestration-img">
                            </div>

                            <!-- <div class="orchestration-features">
                                <div class="orch-category">
                                    <div class="orch-category-title">🎭 人设与回复逻辑</div>
                                    <div class="orch-category-desc">定义智能体的角色定位、行为逻辑和回复风格，支持系统提示词配置与多轮对话策略</div>
                                    <div class="orch-tags">
                                        <span class="orch-tag">角色定义</span>
                                        <span class="orch-tag">回复策略</span>
                                        <span class="orch-tag">提示词工程</span>
                                    </div>
                                </div>

                                <div class="orch-category">
                                    <div class="orch-category-title">🔌 技能与插件系统</div>
                                    <div class="orch-category-desc">灵活配置工具能力，支持API接入、函数调用和第三方服务集成，实现智能体的能力扩展</div>
                                    <div class="orch-tags">
                                        <span class="orch-tag">工具配置</span>
                                        <span class="orch-tag">API接入</span>
                                        <span class="orch-tag">函数调用</span>
                                    </div>
                                </div>

                                <div class="orch-category">
                                    <div class="orch-category-title">🔗 工作流编排</div>
                                    <div class="orch-category-desc">可视化拖拽式工作流设计，支持条件分支、循环逻辑、并行执行等复杂业务流程编排</div>
                                    <div class="orch-tags">
                                        <span class="orch-tag">可视化编排</span>
                                        <span class="orch-tag">条件分支</span>
                                        <span class="orch-tag">循环执行</span>
                                    </div>
                                </div>

                                <div class="orch-category">
                                    <div class="orch-category-title">📚 知识管理</div>
                                    <div class="orch-category-desc">支持文本、表格、图片等多模态知识导入，智能分块与向量化，构建智能体专属知识库</div>
                                    <div class="orch-tags">
                                        <span class="orch-tag">文档处理</span>
                                        <span class="orch-tag">向量检索</span>
                                        <span class="orch-tag">知识图谱</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <!-- 底部两个模块 -->
                        <div class="orchestration-bottom">
                            <div class="orch-category orch-bottom-card">
                                <div class="orch-category-title">🧠 记忆与状态管理</div>
                                <div class="orch-category-desc">变量系统与数据库存储，支持长期记忆、会话状态管理和用户偏好持久化</div>
                                <div class="orch-tags">
                                    <span class="orch-tag">变量系统</span>
                                    <span class="orch-tag">数据持久化</span>
                                    <span class="orch-tag">上下文记忆</span>
                                </div>
                            </div>

                            <div class="orch-category orch-bottom-card">
                                <div class="orch-category-title">💬 对话体验优化</div>
                                <div class="orch-category-desc">开场白配置、用户问题建议、快捷指令设置，打造流畅自然的交互体验</div>
                                <div class="orch-tags">
                                    <span class="orch-tag">开场白</span>
                                    <span class="orch-tag">问题建议</span>
                                    <span class="orch-tag">快捷指令</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 15: Task Management ═══════════ -->
                <div class="slide slide-task-management" data-index="15">
                    <div class="container">
                        <div class="task-header">
                            <h1 class="task-title">任务调度与自动执行</h1>
                            <p class="task-subtitle">通过 Cron 表达式构建统一调度能力，驱动 AI 与工作流按计划自动运行，持续完成周报、月报、信息抓取等例行业务</p>
                        </div>

                        <div class="task-pillars">
                            <div class="task-pillar">
                                <div class="task-pillar-title">灵活调度</div>
                                <div class="task-pillar-desc">支持通过 Cron 表达式定义分钟级、小时级、按周、按月等多种调度策略，满足不同业务节奏。</div>
                            </div>
                            <div class="task-pillar">
                                <div class="task-pillar-title">典型周期任务</div>
                                <div class="task-pillar-desc">适用于周报、月报、日报生成，舆情/政策/行业信息抓取，以及固定时间触发的企业例行任务。</div>
                            </div>
                            <div class="task-pillar">
                                <div class="task-pillar-title">联动工作流</div>
                                <div class="task-pillar-desc">任务调度与工作流打通后，可以自动触发流程执行、调用插件和知识库，实现无人值守的业务运行。</div>
                            </div>
                        </div>

                        <div class="task-content">
                            <div class="task-screenshot">
                                <img :src="require('./image/agent-task.png')" alt="任务管理与 Cron 表达式配置" class="task-image">
                            </div>

                            <!-- <div class="task-right">
                                <div class="task-card">
                                    <div class="task-card-title">任务管理是什么</div>
                                    <div class="task-card-desc">任务管理负责定义什么时候执行、执行什么流程、以什么频率运行。它把一次性的 AI
                                        能力升级为可持续运转的自动化任务体系，支持固定周期、指定时点与长期运行管理。</div>
                                </div>

                                <div class="task-card">
                                    <div class="task-card-title">Cron 让周期任务配置更灵活</div>
                                    <div class="task-card-desc">通过 Cron
                                        表达式，可以精确描述任务执行时间，例如每周一生成周报、每月初生成经营月报、每天定时抓取政策与行业信息，帮助企业把例行工作自动化。</div>
                                    <div class="task-tags">
                                        <span class="task-tag">周报生成</span>
                                        <span class="task-tag">月报生成</span>
                                        <span class="task-tag">信息抓取</span>
                                        <span class="task-tag">定时执行</span>
                                    </div>
                                </div>

                                <div class="task-card">
                                    <div class="task-card-title">结合工作流实现自动执行</div>
                                    <div class="task-card-desc">
                                        任务管理与工作流结合后，不仅能按时触发，还能自动完成数据抓取、内容汇总、报告生成、消息发送等完整链路，真正实现从“定时启动”到“自动交付”的闭环执行。
                                    </div>
                                    <div class="task-tags">
                                        <span class="task-tag">触发工作流</span>
                                        <span class="task-tag">自动跑流程</span>
                                        <span class="task-tag">结果交付</span>
                                        <span class="task-tag">无人值守</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="task-summary">
                            <strong>任务调度</strong> 解决的是“AI 能力如何持续、定时、自动运行”的问题。结合 Cron
                            与工作流，企业可以把原本依赖人工触发的例行工作，升级为可计划、可执行、可交付的自动化任务系统。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 16: Permission Management ═══════════ -->
                <div class="slide slide-permission-management" data-index="16">
                    <div class="container">
                        <div class="permission-header">
                            <h1 class="permission-title">权限治理与分级可见</h1>
                            <p class="permission-subtitle">
                                通过统一权限治理能力，按角色、岗位与业务场景配置不同能力的管理权限与可见范围，实现平台能力按组织边界开放、按岗位职责精准使用</p>
                        </div>

                        <div class="permission-pillars">
                            <div class="permission-pillar">
                                <div class="permission-pillar-title">角色分级</div>
                                <div class="permission-pillar-desc">支持根据管理员、业务负责人、普通员工等不同角色，配置不同层级的管理与使用权限。</div>
                            </div>
                            <div class="permission-pillar">
                                <div class="permission-pillar-title">能力分级可见</div>
                                <div class="permission-pillar-desc">可对智能体、工作流、知识库等能力设置分级可见范围，避免无关人员接触不必要的能力入口。</div>
                            </div>
                            <div class="permission-pillar">
                                <div class="permission-pillar-title">岗位定向使用</div>
                                <div class="permission-pillar-desc">根据不同业务岗位配置不同能力组合，让设计、运营、财务、销售等岗位看到并使用各自需要的能力。</div>
                            </div>
                        </div>

                        <div class="permission-content">
                            <div class="permission-screenshot">
                                <img :src="require('./image/agent-permission.png')" alt="分级管理权限配置"
                                    class="permission-image">
                            </div>

                            <!-- <div class="permission-right">
                                <div class="permission-card">
                                    <div class="permission-card-title">统一管理不同角色的能力权限</div>
                                    <div class="permission-card-desc">
                                        分级管理权限用于统一控制谁能看、谁能用、谁能管。它让平台中的不同角色按照职责边界获取对应权限，既保障使用效率，也降低误操作和权限扩散风险。</div>
                                </div>

                                <div class="permission-card">
                                    <div class="permission-card-title">支持对智能体、工作流、知识库进行分级可见</div>
                                    <div class="permission-card-desc">
                                        平台可针对智能体、工作流、知识库等能力对象设置不同的可见与管理范围，实现按部门、按岗位、按角色配置能力入口，让不同人员只看到和自己相关的能力。</div>
                                    <div class="permission-tags">
                                        <span class="permission-tag">智能体可见</span>
                                        <span class="permission-tag">工作流可见</span>
                                        <span class="permission-tag">知识库可见</span>
                                        <span class="permission-tag">角色授权</span>
                                    </div>
                                </div>

                                <div class="permission-card">
                                    <div class="permission-card-title">让不同业务岗位使用不同能力</div>
                                    <div class="permission-card-desc">
                                        通过分级权限配置，设计岗位可使用设计类知识库与工作流，运营岗位可访问内容与投放类能力，财务岗位可使用报表与审批相关流程，真正实现按岗位精准供给能力。</div>
                                    <div class="permission-tags">
                                        <span class="permission-tag">岗位隔离</span>
                                        <span class="permission-tag">能力定向</span>
                                        <span class="permission-tag">安全治理</span>
                                        <span class="permission-tag">组织协同</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="permission-summary">
                            <strong>权限治理</strong> 解决的是“不同角色应该使用哪些能力”的问题。它让平台能力在组织内部安全、有序、按岗位地流转，实现既能开放共享，又能边界清晰的企业级治理。
                        </div>
                    </div>
                </div>

                <!-- ═══════════ Slide 17: API Integration ═══════════ -->
                <div class="slide slide-api-integration" data-index="17">
                    <div class="container">
                        <div class="api-header">
                            <h1 class="api-title">开放 API 与生态集成</h1>
                            <p class="api-subtitle">通过开放 API 将平台底层能力标准化输出，支持第三方系统与生态伙伴快速集成平台能力，并基于这些能力构建自己的智能体应用</p>
                        </div>

                        <div class="api-pillars">
                            <div class="api-pillar">
                                <div class="api-pillar-title">能力开放</div>
                                <div class="api-pillar-desc">通过开放 API 将会话、工作流、文件处理等核心能力标准化输出，方便第三方系统直接接入使用。</div>
                            </div>
                            <div class="api-pillar">
                                <div class="api-pillar-title">系统集成</div>
                                <div class="api-pillar-desc">外部业务系统可以通过 API Key、接口文档与标准协议快速完成集成，打通原有业务入口与 AI 能力底座。</div>
                            </div>
                            <div class="api-pillar">
                                <div class="api-pillar-title">快速构建智能体</div>
                                <div class="api-pillar-desc">第三方系统无需重复建设底层能力，即可复用平台架构与组件，快速组装自己的智能体与智能应用。</div>
                            </div>
                        </div>

                        <div class="api-content">
                            <div class="api-screenshot">
                                <img :src="require('./image/agent-apikey.png')" alt="开放 API 与第三方集成能力" class="api-image">
                            </div>

                            <!-- <div class="api-right">
                                <div class="api-card">
                                    <div class="api-card-title">平台能力可通过 API 对外暴露</div>
                                    <div class="api-card-desc">
                                        平台不仅提供可视化界面，也将底层能力通过开放接口输出给外部系统。无论是智能问答、工作流执行，还是文件处理与会话能力，都可以通过标准 API 被第三方调用。
                                    </div>
                                </div>

                                <div class="api-card">
                                    <div class="api-card-title">第三方系统可快速完成能力接入</div>
                                    <div class="api-card-desc">借助 API
                                        Key、接入说明和接口文档，第三方系统可以在现有业务场景中快速嵌入平台能力，把原有应用与智能体底座打通，减少重复开发和系统割裂。</div>
                                    <div class="api-tags">
                                        <span class="api-tag">API Key</span>
                                        <span class="api-tag">接口文档</span>
                                        <span class="api-tag">标准接入</span>
                                        <span class="api-tag">系统打通</span>
                                    </div>
                                </div>

                                <div class="api-card">
                                    <div class="api-card-title">帮助其他系统快速构建自己的智能体</div>
                                    <div class="api-card-desc">
                                        外部系统可以直接复用平台的模型能力、工作流能力、知识库能力和执行能力，在自身业务场景中快速构建定制化智能体，实现“保留原有系统入口，叠加智能体能力”的快速升级。
                                    </div>
                                    <div class="api-tags">
                                        <span class="api-tag">复用底座能力</span>
                                        <span class="api-tag">快速构建智能体</span>
                                        <span class="api-tag">降低开发成本</span>
                                        <span class="api-tag">生态集成</span>
                                    </div>
                                </div>
                            </div> -->
                        </div>

                        <div class="api-summary">
                            <strong>开放 API</strong> 解决的是“平台能力如何被外部系统与生态伙伴复用”的问题。它让 AIPas
                            不只是一个独立平台，更成为可被第三方系统接入、组合和扩展的智能体能力底座。
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
import { getJsonTree } from '@/utils/index'
var isMouseDown = false;
var ul = null;
export default {
    data() {
        return {
            action: window['pathConfig'][process.env.NODE_ENV].ImgURL,
            index: 0,
            mindex: '',
            menu: [
                {
                    title: 'AI智能体中台',
                    text: '从工具到组织，从单点到协同，从公有到私有，构建属于企业自己的智能体平台',
                    // info: '基于OpenClaw开源AI智能体框架，构建企业专属的“数据智能军团”。与个人版“小龙虾”不同，企业小龙虾聚焦数据采集、清洗、分析与报告生成全流程自动化，通过多智能体协同，将分散在内部系统、公开渠道的异构数据转化为可执行的业务洞察，让数据资产真正“活起来”。',
                    // img: require('@/assets/AI/小龙虾.jpg'),
                    // hxgn: [
                    //     {
                    //         title: '智能数据采集Agent',
                    //         text: '基于OpenClaw Scout模块，支持自动抓取企业内部数据库、API、Excel/PDF文档，以及公开网页、社交媒体、竞品官网等渠道数据。可自定义采集规则（定时、事件触发），自动识别新增数据并增量同步，彻底告别手动导出导入。'
                    //     },
                    //     {
                    //         title: '多智能体协同分析',
                    //         text: '借鉴“Manager/Worker”多智能体架构 ：Manager Agent负责拆解复杂分析任务，分配至专业Worker（如数据清洗Agent、关联分析Agent、异常检测Agent）并行执行。各Agent独立运行、隔离内存，避免上下文污染，确保分析精准高效。'
                    //     },
                    //     {
                    //         title: '自动报告生成',
                    //         text: '分析结果自动输入报告生成Agent，基于预设模板（日报/周报/专题报告）一键生成结构化文档，包含数据图表、趋势分析、结论建议。支持PDF/Word/Excel多格式导出，可同步推送至企业微信、飞书、钉钉。'
                    //     },
                    //     {
                    //         title: '私有化安全部署',
                    //         text: '支持完全私有化部署，所有数据留存企业内部。内置企业级安全增强套件，实现细粒度权限管控、操作审计、插件沙箱隔离。可对接企业现有IAM系统，确保数据合规与安全。'
                    //     }
                    // ],
                    // card: [
                    //     {
                    //         title: '市场竞品监测',
                    //         text: '自动采集竞品官网、行业论坛、社交媒体信息，实时监测价格变动、新品发布、舆情动态，生成竞品周报，辅助市场策略制定。',
                    //     },
                    //     {
                    //         title: '供应链风险预警',
                    //         text: '整合采购数据、物流信息、供应商新闻，构建供应链风险热力图，发现交货延迟、原材料涨价等苗头，自动触发预警并推送替代方案建议。',
                    //     },
                    //     {
                    //         title: '财务数据分析',
                    //         text: '自动从ERP、财务系统采集数据，生成月度经营分析报告，涵盖收入/成本趋势、预算执行率、异常波动归因分析，财务人员从“做表”转向“看数”。',
                    //     },
                    //     {
                    //         title: '客户之声洞察',
                    //         text: '基于企业微信会话存档，分析客户投诉、咨询、反馈中的高频问题和情绪趋势，生成服务质量报告，推动产品和服务优化。',
                    //     },
                    //     {
                    //         title: '研发知识沉淀',
                    //         text: '自动抓取散落在Confluence、GitLab、邮件中的技术文档、代码注释、会议纪要，构建研发知识图谱，支持自然语言检索，减少重复造轮子。',
                    //     },
                    //     {
                    //         title: '销售商机挖掘',
                    //         text: '分析销售聊天记录中的购买信号（比价、扩容、竞品对比），自动标记高意向客户，生成客户画像和跟进建议，推送至销售主管。',
                    //     },
                    //     {
                    //         title: '合规审计辅助',
                    //         text: '自动扫描合同、邮件、聊天记录中的合规风险（如敏感词、违规承诺），生成审计报告，标注风险点及处置建议，满足监管要求。',
                    //     },
                    //     {
                    //         title: '运营数据看板',
                    //         text: '整合多业务系统数据，自动生成运营日报/周报，包含核心指标趋势、异常波动预警，管理层可一键查看，告别手动汇总。',
                    //     },
                    //     {
                    //         title: '',
                    //         text: '',
                    //     }
                    // ],
                    // hxjz: [
                    //     {
                    //         title: '效率跃升，一人抵一队',
                    //         titleb: '',
                    //         text: '数据采集、清洗、分析、报告全流程自动化，将分析师从重复劳动中解放，复杂分析任务从“天”级缩短至“分钟”级。'
                    //     },
                    //     {
                    //         title: '多智能体协同，专业分工',
                    //         titleb: '',
                    //         text: 'Manager/Worker架构确保任务拆解清晰、专业Agent专注执行，避免“全能Agent”的记忆臃肿和逻辑冲突，分析质量更高。'
                    //     }, {
                    //         title: '私有化部署，安全合规',
                    //         titleb: '',
                    //         text: '数据不出域，权限可控，满足金融、政务等高敏行业监管要求；开源框架+企业级安全增强，无厂商锁定风险。'
                    //     }, {
                    //         title: '持续沉淀，越用越聪明',
                    //         titleb: '',
                    //         text: '分析模板、报告格式、采集规则可复用、可优化，企业数据资产持续积累，分析能力随业务进化而提升。'
                    //     }, {
                    //         title: '无缝集成，即装即用',
                    //         titleb: '',
                    //         text: '与企业微信、飞书、钉钉深度集成，分析结果可自动推送至工作群；支持API对接现有BI、数据中台，快速嵌入现有流程。'
                    //     }
                    // ],
                    // gnzs: [
                    //     require('@/assets/AI/gnzs25.png'),
                    //     require('@/assets/AI/gnzs26.png')
                    // ]
                },
                {
                    title: 'AI舆情监测',
                    text: '企业微信会话存档 + AI语义理解，让内部沟通风险无处遁形',
                    info: '基于AI大模型深度分析企业微信聊天内容，精准识别敏感信息泄露与舆情风险，变被动处置为主动预警，帮助企业筑牢信息安全防线。',
                    img: require('@/assets/AI/cp-ai-2.jpg'),
                    hxgn: [
                        {
                            title: '智能语义理解',
                            text: '基于AI大模型，对企业微信聊天内容进行深度语义分析，准确识别用户真实意图。当触发预设关键词时，系统自动判断是正常讨论、情绪宣泄、恶意投诉还是敏感信息泄露，大幅降低误报率。'
                        },
                        {
                            title: '敏感信息监测',
                            text: '自定义设置敏感词库（如产品配方、实验数据、未公开财报等），AI实时扫描群聊与单聊内容，结合上下文判断是否存在潜在泄露风险，一旦发现异常立即预警，防止内部信息外泄。'
                        },
                        {
                            title: '实时预警推送',
                            text: '识别到舆情风险或敏感行为后，系统通过企业微信实时推送预警至指定管理人员，包含风险类型、触发内容、上下文截图及处置建议，支持分级通知，确保快速响应。'
                        },
                        {
                            title: '分析记录与追溯',
                            text: '所有风险事件的分析记录自动归档，管理后台可随时查阅历史记录、处置进度和趋势分析。支持多维度筛选与导出，为内部合规审计和安全策略优化提供数据支撑。'
                        }
                    ],
                    card: [
                        {
                            title: '客户投诉预警',
                            text: '实时识别聊天中的投诉、抱怨等负面情绪，及时介入处理，防止客诉升级。',
                        },
                        {
                            title: '员工情绪监测',
                            text: '监测员工对企业政策、管理的不满情绪，提前发现团队不稳定因素，辅助管理决策。',
                        },
                        {
                            title: '敏感词防泄露',
                            text: '监测产品配方、实验数据、客户信息等敏感词泄露，防范商业机密外流。',
                        },
                        {
                            title: '竞品讨论监控',
                            text: '识别员工在群聊中讨论竞品、跳槽意向等行为，及时发现潜在人才流失风险。',
                        },
                        {
                            title: '内部风险行为识别',
                            text: '监测私单、飞单、私加客户等违规行为，结合上下文分析意图，降低经营风险。',
                        },
                        {
                            title: '合规审计辅助',
                            text: '自动留存风险分析记录，满足合规审计要求，支持导出报告供内部审查。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '主动预防',
                            titleb: '风险前置',
                            text: '从被动抽查到全量实时监测，将舆情风险消灭在萌芽状态。'
                        },
                        {
                            title: '精准识别',
                            titleb: '降低误报',
                            text: '大模型语义理解取代关键词机械匹配，准确区分调侃、引用与真实投诉。'
                        }, {
                            title: '防患未然',
                            titleb: '保障机密',
                            text: '实时监测敏感信息泄露，守护企业核心资产安全。'
                        }, {
                            title: '数据驱动',
                            titleb: '管理有据',
                            text: '沉淀风险分析数据，生成趋势报告，为内部管理优化提供依据。'
                        }, {
                            title: '轻量集成',
                            titleb: '快速部署',
                            text: '与企业微信无缝对接，无需改变员工使用习惯，即装即用。'
                        }
                    ],
                    // gnzs: [
                    //     require('@/assets/AI/gnzs4.png'),
                    //     require('@/assets/AI/gnzs5.png'),
                    // ],
                    gnzsb: [
                        {
                            title: 'AI聊天预警',
                            img: require('@/assets/AI/图层 73.png'),
                            width: '32%',
                        }, {
                            title: '群聊内容监测',
                            img: require('@/assets/AI/群聊内容监测.png'),
                            width: '50%',
                        }, {
                            title: '智能业务流程',
                            img: require('@/assets/AI/图层 77.png'),
                            width: '85%',
                        }
                    ]
                },
                {
                    title: '智慧财务服务助手',
                    text: '自然语言交互+流程自动化，打造全员畅享的智能财务体验',
                    info: '整合财务咨询、进度查询、催办通知等高频场景，让员工随时问、随时查，让财务人员高效管、轻松催，全面提升财务服务效率与透明度。',
                    img: require('@/assets/AI/cp-ai-3.jpg'),
                    hxgn: [
                        {
                            title: '智能财务问答',
                            text: '基于财务知识库，支持自然语言提问（如“报销标准”“公积金提取流程”），准确解答员工常见问题，减少财务重复咨询，提升响应速度。'
                        },
                        {
                            title: '流程进度查询',
                            text: '员工可随时查看自己提交的报销、付款、借款等申请进度，实时了解当前节点和预计完成时间，流程透明可控，告别焦虑等待。'
                        },
                        {
                            title: '智能催办与通知',
                            text: '系统根据流程时限自动发送催办提醒给审批人，财务人员也可手动发起催办；关键节点自动通知申请人，信息及时触达，推动流程高效流转。'
                        },
                        {
                            title: '数据看板与管理后台',
                            text: '财务人员和管理员可查看流程处理效率、咨询热点、待办任务等数据，支持批量通知、流程干预，持续优化财务运营。'
                        }
                    ],
                    card: [
                        {
                            title: '员工报销咨询',
                            text: '员工提问“差旅费报销标准”，AI立即给出政策摘要和附件指引，无需等待财务回复。',
                        },
                        {
                            title: '进度自助查询',
                            text: '员工输入“我的报销单到哪了”，系统展示当前审批节点和预计时间，心中有数。',
                        },
                        {
                            title: '财务催办任务',
                            text: '财务人员在后台一键催办超时审批，系统自动发送提醒给审批人，减少人工跟进。',
                        },
                        {
                            title: '批量通知发布',
                            text: '财务通过助手发布公积金基数调整通知，全员或指定部门即时收到，确保信息传达。',
                        },
                        {
                            title: '预算余额查询',
                            text: '部门负责人查询本部门预算使用情况，辅助支出决策，避免超支。',
                        },
                        {
                            title: '新员工入职指引',
                            text: '新员工咨询“如何办理工资卡”，助手提供流程和材料清单，快速融入。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '提升员工体验',
                            titleb: '',
                            text: '7×24小时自助服务，告别“等回复”，财务问题随时解决。'
                        },
                        {
                            title: '降低沟通成本',
                            titleb: '',
                            text: '减少重复咨询和催促，释放财务人力投入高价值工作。'
                        }, {
                            title: '流程透明高效',
                            titleb: '',
                            text: '进度实时可见，催办自动化，审批效率大幅提升。'
                        }, {
                            title: '数据驱动管理',
                            titleb: '',
                            text: '沉淀财务咨询与流程数据，持续优化服务与政策。'
                        }, {
                            title: '安全可控',
                            titleb: '',
                            text: '权限分级管理，确保敏感信息仅对授权人员开放。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs6.png'),
                        // require('@/assets/AI/gnzs7.png'),
                        // require('@/assets/AI/gnzs8.png')
                    ],
                    gnzsb: [
                        {
                            title: 'AI智能体财务助手',
                            img: require('@/assets/AI/gnzs6.png'),
                            width: 'auto',
                        }, {
                            title: '智能体会话',
                            img: require('@/assets/AI/gnzs7.png'),
                            width: 'auto',
                        }, {
                            title: '智能业务流程',
                            img: require('@/assets/AI/gnzs8.png'),
                            width: 'auto',
                        }
                    ]
                },
                {
                    title: 'AI知识库',
                    text: '多源数据接入+智能语义理解，构建企业级知识中枢',
                    info: '将分散在产品说明书、技术文档、FAQ等资料中的知识，通过智能解析与向量化技术，统一构建成可被AI调用的知识库，为业务应用提供高质量数据源，让知识从“存起来”到“用起来”。',
                    img: require('@/assets/AI/cp-ai-4.jpg'),
                    hxgn: [
                        {
                            title: '多源异构数据接入',
                            text: '支持批量导入多种格式文档（PDF、Word、PPT、Excel等），同时提供API、数据库直连、网页抓取等方式，快速汇聚分散数据，打破系统孤岛，为知识库建设奠定基础。'
                        },
                        {
                            title: '智能文档处理与解析',
                            text: '精准解析复杂排版文件（如带表格、多栏的PDF），解决长文档结构混乱问题，自动清洗冗余内容，提取核心文本、图表信息，确保知识干净可用。'
                        },
                        {
                            title: '智能分块与向量化',
                            text: '突破大模型上下文窗口限制，通过智能分块算法将文档切分为语义完整的片段，并转化为向量数据，使知识库从字面匹配升级为语义理解。'
                        },
                        {
                            title: '混合检索与召回',
                            text: '结合向量检索与关键词检索，快速召回相似片段，并通过重排序剔除低相关性内容，将最匹配的片段输入大模型，显著提升问答准确性和用户体验。'
                        }
                    ],
                    card: [
                        {
                            title: '研发知识协同',
                            text: '研发团队分散多地，技术文档版本混乱。AI知识库统一管理产品文档、技术方案，支持语义搜索，快速复用历史方案，提升协作效率。',
                        },
                        {
                            title: '客服智能问答',
                            text: '客服人员面对客户复杂问题，可在知识库中快速获取标准答案，或通过AI助手自动回复，提高问题解决率和响应速度。',
                        },
                        {
                            title: '合规审计辅助',
                            text: '财务、法务等岗位需频繁查阅合规文档。知识库自动抓取最新政策法规，支持自然语言查询，确保业务操作合规，降低审计风险。',
                        },
                        {
                            title: '员工自助问答',
                            text: '新员工入职可通过知识库自助查询制度、流程、常见问题，减少对HR、IT的重复咨询，快速上手工作。',
                        },
                        {
                            title: '销售赋能',
                            text: '销售人员在客户现场可随时查询产品参数、案例、竞品对比，生成定制方案，提升成单率。',
                        },
                        {
                            title: '员工培训',
                            text: '将培训资料、操作手册纳入知识库，新员工随时学习，老员工快速回顾，降低培训成本。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '激活数据资产',
                            titleb: '',
                            text: '将分散的文档、资料转化为可检索、可利用的知识资产，释放企业隐性知识。'
                        },
                        {
                            title: '提升检索效率',
                            titleb: '',
                            text: '语义理解替代关键词匹配，让员工快速找到所需信息，减少无效查找时间。'
                        }, {
                            title: '支撑AI应用',
                            titleb: '',
                            text: '为智能客服、问答机器人、业务助手等提供高质量知识源，提升AI回答准确性。'
                        }, {
                            title: '降低管理成本',
                            titleb: '',
                            text: '自动化清洗、分块、向量化，减少人工整理投入，知识更新更及时。'
                        }, {
                            title: '安全可控',
                            titleb: '',
                            text: '权限分级管理，确保敏感知识仅对授权人员开放。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs9.png'),
                        require('@/assets/AI/gnzs10.png')
                    ]
                },
                {
                    title: 'AI智能客服',
                    text: '生成式AI + 全渠道对话引擎，让每一次服务都更智能、更温暖',
                    info: '基于大模型构建的智能客服系统，支持多轮对话、复杂语义理解与情绪识别，可自动生成个性化解决方案并联动业务系统（如自动创建工单、查询订单），覆盖产品咨询、售后处理、销售挖掘等场景，问题解决率提升至89%。',
                    img: require('@/assets/AI/cp-ai-5.jpg'),
                    hxgn: [
                        {
                            title: '可视化流程编排',
                            text: '支持通过可视化拖拉拽方式编排原子能力，快速搭建复杂对话流程，覆盖产品咨询、订单寄送、信息查询等40余类任务，显著节省人工座席工作量，提升服务效率。'
                        },
                        {
                            title: '多轮意图收集',
                            text: '通过多轮对话主动收集客户意图，如故障描述、产品型号、购买意向等，精准定位客户需求，为后续流程化处理提供完整信息。'
                        },
                        {
                            title: '大模型+代码节点',
                            text: '集成大模型节点，支持复杂语义理解和生成式回复；同时提供代码节点，可执行定制化逻辑（如价格计算、库存校验），满足个性化业务场景。'
                        },
                        {
                            title: '业务系统联动',
                            text: '与CRM、ERP、工单系统无缝集成，识别客户意图后自动触发业务动作：创建售后工单、查询物流状态、推送优惠券、转接人工专家等，实现服务闭环。'
                        },
                        {
                            title: '情绪识别与分级应对',
                            text: '实时检测客户语音语调、文字关键词，识别愤怒、焦虑等负面情绪，自动调整回复策略，比如发送安抚话术或进度通知；严重冲突秒转人工专家，并推送客户画像和历史记录，助力快速平息投诉。'
                        }
                    ],
                    card: [
                        {
                            title: '产品咨询与推荐',
                            text: '客户询问“适合办公室的咖啡机”，AI根据需求推荐型号、对比功能，并推送购买链接，同时记录意向。',
                        },
                        {
                            title: '售后故障报修',
                            text: '客户上传设备故障视频，AI自动诊断问题，生成图文版排查指南，如需维修则一键创建工单，预约工程师。',
                        },
                        {
                            title: '订单物流查询',
                            text: '客户输入“我的订单到哪了”，AI实时查询物流状态，主动推送最新进度，并提醒签收注意事项。',
                        },
                        {
                            title: '销售机会挖掘',
                            text: '识别客户咨询中的比价、扩容等信号，自动标记高意向对话，生成客户画像并推送销售部门跟进。',
                        },
                        {
                            title: '投诉与情绪安抚',
                            text: '检测到客户情绪激动，AI自动降低语速、表达歉意，并升级至人工专家，同时推送客户历史交互记录，助力快速解决。',
                        },
                        {
                            title: '多轮信息收集',
                            text: '在办理退换货流程中，通过多轮对话收集订单号、退货原因、照片凭证，自动生成退换货申请，减少人工录入。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '提升服务效率',
                            titleb: '',
                            text: '7×24小时秒级响应，自动处理80%常规咨询，人工聚焦复杂问题。'
                        },
                        {
                            title: '优化客户体验',
                            titleb: '',
                            text: '精准理解客户意图，个性化回复，情绪识别让服务更有温度。'
                        }, {
                            title: '降低运营成本',
                            titleb: '',
                            text: '减少人工座席投入，缩短培训周期，可视化编排降低运维门槛。'
                        }, {
                            title: '挖掘销售机会',
                            titleb: '',
                            text: '自动识别购买信号，推送销售线索，助力业绩增长。'
                        }, {
                            title: '数据驱动优化',
                            titleb: '',
                            text: '沉淀对话数据，分析热点问题，持续优化知识库和业务流程。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs11.png'),
                        require('@/assets/AI/gnzs12.png'),
                        require('@/assets/AI/gnzs13.png')
                    ]
                },
                {
                    title: '智能安防AI预警',
                    text: '无人机巡检 + AI图像识别，构建主动防御新范式',
                    info: '告别人工盯防与滞后响应，让AI实时发现人员违规、物品隐患、环境异常，第一时间推送至责任人，形成“发现-处置-归档”完整闭环，全面提升园区安全等级。',
                    img: require('@/assets/AI/cp-ai-1.jpg'),
                    hxgn: [
                        {
                            title: '全场景智能识别',
                            text: 'AI实时分析无人机批量照片，精准识别人员违规（翻墙、入侵、违规作业）、物品隐患（遗留物、违停、设备异常）和环境风险（烟火、积水、扬尘），识别准确率≥95%。'
                        },
                        {
                            title: '无人机自动巡检',
                            text: '支持自定义航线与重点区域（围墙、危化品库），无人机定时或事件触发巡检，画面实时回传；支持存量照片批量上传审核，快速追溯历史风险。'
                        },
                        {
                            title: '企业微信实时预警',
                            text: '识别风险后，系统通过企业微信秒级推送预警，包含风险类型、位置截图、处置建议。支持分级推送、群组提醒、@指定人员，并可配置不同风险等级的通知策略，确保责任人第一时间响应。'
                        },
                        {
                            title: '闭环处置流程',
                            text: '责任人接收预警后可在企业微信确认、转派任务；现场处置上传照片、填写结果，系统自动记录进度。超时未处理自动督办，形成“接收—处置—反馈—归档”完整闭环。'
                        }
                    ],
                    card: [
                        {
                            title: '园区周界',
                            text: '实时识别翻墙、攀爬、靠近警戒线等行为，夜间配合热成像，杜绝非法入侵。',
                        },
                        {
                            title: '危化品仓库',
                            text: '监测烟火、人员违规闯入、设备过热，提前预防重大事故。',
                        },
                        {
                            title: '施工现场',
                            text: '识别未戴安全帽、违规作业、材料乱堆放，保障人员与设施安全。',
                        },
                        {
                            title: '设备巡检',
                            text: '无人机定期巡检电力设施、管道、光伏板，AI自动发现锈蚀、破损、异物附着。',
                        },
                        {
                            title: '大型活动',
                            text: '实时监测人群密度、异常奔跑、聚集斗殴，辅助现场指挥快速调度。',
                        },
                        {
                            title: '环境监测',
                            text: '识别露天焚烧、扬尘、积水，及时预警环境污染与内涝风险。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '预防为主',
                            titleb: '主动发现',
                            text: 'AI 7×24小时不间断巡检，将风险消灭在萌芽状态，大幅降低安全事故发生率。'
                        },
                        {
                            title: '流程闭环',
                            titleb: '责任到人',
                            text: '预警、处置、反馈全程线上化，责任清晰，处置效率显著提升。'
                        }, {
                            title: '数据驱动',
                            titleb: '持续优化',
                            text: '沉淀安全数据资产，通过趋势分析不断优化安防策略，让管理更科学。'
                        }, {
                            title: '轻量部署',
                            titleb: '快速见效',
                            text: '与企业微信无缝集成，无需更换现有监控设备，即可快速上线使用。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs1.png'),
                        require('@/assets/AI/gnzs2.png'),
                        require('@/assets/AI/gnzs3.png')
                    ]
                },
                {
                    title: '智能运维接管',
                    text: 'AI知识库 + 智能分流引擎，让设备报修从此“不绕路”',
                    info: '将报修知识文档提前接入AI知识库，员工报修时，AI自动分析故障描述，精准判断问题类型——软件问题直接派单给IT人员，硬件问题先提供自助排查建议再通知维修人员。报修人可根据建议自助解决并一键确认，大幅缩短处理周期，让运维流程更顺畅。',
                    img: require('@/assets/AI/智能运维.jpg'),
                    hxgn: [
                        {
                            title: '智能报修分析',
                            text: '员工提交报修时，AI基于报修描述（文字/图片/语音转文字），结合知识库中的故障案例、设备手册，自动识别问题类型、紧急程度和可能原因。'
                        },
                        {
                            title: '自动分流与派单',
                            text: '根据分析结果自动分流：软件问题（如系统卡顿、应用报错）直接生成工单，推送至对应IT人员；硬件问题（如设备无法开机、零件损坏）先生成自助排查建议，推送给报修人尝试解决，若未解决再派单给维修人员。'
                        },
                        {
                            title: '知识库辅助建议',
                            text: '提前将设备说明书、常见故障库、维修手册等文档接入AI知识库，报修时AI自动匹配相似案例，生成图文并茂的排查指南和操作建议，供报修人自助尝试。'
                        },
                        {
                            title: '闭环处置与确认',
                            text: '报修人可根据AI建议自助解决问题后，一键点击“已解决”，流程自动归档；若问题未解决，维修人员接单后可在工单中查看AI预分析结果和报修人尝试记录，快速定位问题，完成后报修人确认闭环。'
                        }
                    ],
                    card: [
                        {
                            title: '办公电脑报修',
                            text: '员工提交“电脑蓝屏，代码0x0000f”，AI识别为软件问题，自动推送IT人员远程修复，并附带常见解决方案。',
                        },
                        {
                            title: '会议室设备故障',
                            text: '会议室投影无法连接，AI分析可能是线缆松动或信号源设置问题，推送自助排查步骤，员工按指引操作后解决，无需等待IT。',
                        },
                        {
                            title: '打印机/复印机问题',
                            text: '打印机卡纸，AI根据描述推送卡纸清除视频和步骤，员工自助清理后点击确认，工单自动关闭。',
                        },
                        {
                            title: '网络故障报修',
                            text: '员工反馈“办公室WiFi无法连接”，AI判断可能是AP故障或认证问题，先推送重启AP建议，若无效则派单给网络工程师。',
                        },
                        {
                            title: '门禁/安防设备报修',
                            text: '门禁刷卡无反应，AI提示检查电源和网络连接，若仍无法解决则生成工单派给弱电维修人员，附带设备位置和故障日志。',
                        },
                        {
                            title: '服务器/机房告警',
                            text: '机房温度告警，AI自动关联空调设备状态，推送可能原因（空调故障、滤网堵塞），并通知运维人员处理。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '响应速度大幅提升',
                            titleb: '',
                            text: 'AI秒级分析，无需人工沟通，问题即时报、即刻分流。'
                        },
                        {
                            title: '减轻运维负担',
                            titleb: '',
                            text: '常见问题自助解决，运维人员从琐碎咨询中解放，专注复杂故障。'
                        }, {
                            title: '知识沉淀复用',
                            titleb: '',
                            text: '每次报修与解决过程自动归档，持续丰富知识库，越用越聪明。'
                        }, {
                            title: '流程透明闭环',
                            titleb: '',
                            text: '报修人实时掌握进度，解决后一键确认，信息同步无遗漏。'
                        }, {
                            title: '降低运营成本',
                            titleb: '',
                            text: '减少无效派单和重复沟通，整体维修效率提升，设备停机时间缩短。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs14.png'),
                        // require('@/assets/AI/gnzs15.png')
                    ], gnzsb: [{
                        title: 'AI识别硬件问题',
                        img: require('@/assets/AI/AI识别硬件问题.jpg'),
                        width: 'auto'
                    }, {
                        title: 'AI识别软件问题',
                        img: require('@/assets/AI/AI识别软件问题.jpg'),
                        width: 'auto'
                    }, {
                        title: '智能体对话流程配置',
                        img: require('@/assets/AI/智能体对话流程配置.png'),
                        width: 'auto'
                    }
                    ]
                },
                {
                    title: '网络日志智能报表',
                    text: 'RPA + AI 自动采集分析，让安全报告从“人工整理”到“智能生成”',
                    info: '通过RPA机器人自动采集网络、算力、安全等多源日志，AI深度分析后生成结构化信息安全月报，清晰标注高、中、低风险等级，帮助安全团队快速掌握整体态势，及时应对隐患，大幅提升日志分析效率。',
                    img: require('@/assets/AI/网络日志.jpg'),
                    hxgn: [
                        {
                            title: 'RPA自动日志采集',
                            text: '通过RPA机器人定时从网络设备、服务器、安全设备（防火墙、IDS等）自动导出日志，支持多格式（syslog、文本、CSV），统一存放至指定目录，实现无人值守的全量采集。'
                        },
                        {
                            title: 'AI智能分析',
                            text: 'AI对日志数据进行深度解析，通过NLP提取关键字段（时间、IP、事件类型、威胁指标），识别异常登录、暴力破解、恶意流量等安全事件，并聚类分析高频风险。'
                        },
                        {
                            title: '风险等级评估',
                            text: '基于内置威胁情报和规则库，AI将每起安全事件划分为高危、中危、低危等级。高危项自动触发额外标记和摘要说明，确保重点关注。'
                        },
                        {
                            title: '报表自动生成与分发',
                            text: '根据预设模板（日报/周报/月报），AI自动生成结构化报告，包含风险总览、等级分布、趋势图表、TOP事件清单，支持PDF/Excel/Word导出，并可自动推送至企业微信、邮件或安全管理员。'
                        }
                    ],
                    card: [
                        {
                            title: '信息安全月报生成',
                            text: '每月初，RPA自动采集上月全量日志，AI分析后生成包含高危事件统计、攻击来源分布、漏洞趋势的完整月报，安全负责人可快速掌握整体安全状况。',
                        },
                        {
                            title: '合规审计报告',
                            text: '等保、ISO27001等合规检查前，系统自动生成合规所需的日志审计报告，涵盖日志留存情况、异常行为记录、处置记录，大幅节省迎检准备时间。',
                        },
                        {
                            title: '日常安全巡检',
                            text: '每日/每周自动生成安全巡检简报，列出新增高风险事件、未处置威胁、异常流量波动，帮助运维团队及时发现并处置隐患。',
                        },
                        {
                            title: '应急响应复盘',
                            text: '发生安全事件后，AI快速分析相关日志，生成事件时间线、攻击路径、受影响资产报告，支撑溯源分析和整改复盘。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率革命',
                            titleb: '',
                            text: '从数天的人工整理缩短至分钟级自动生成，释放安全团队精力。'
                        },
                        {
                            title: '降低漏报',
                            titleb: '',
                            text: 'AI 7×24小时不间断分析，不放过任何可疑行为，高危风险无处遁形。'
                        }, {
                            title: '标准规范',
                            titleb: '',
                            text: '报告格式统一、内容完整，满足内部管理和外部合规双重需求。'
                        }, {
                            title: '数据沉淀',
                            titleb: '',
                            text: '历史报告自动归档，支持趋势分析，安全策略优化有据可依。'
                        }, {
                            title: '轻量部署',
                            titleb: '',
                            text: 'RPA+AI方案与现有日志系统无缝集成，无需更换设备，即装即用。'
                        }
                    ],
                    gnzs: [
                        require('@/assets/AI/gnzs16.png'),
                        require('@/assets/AI/gnzs17.png'),
                        require('@/assets/AI/gnzs18.png')
                    ]
                },
                {
                    title: '招投标肋手',
                    text: 'AI解析+智能比对，让招投标审核从“逐页翻看”到“一键洞察”',
                    info: '上传招标文件，AI自动提取核心要求、资质条件、评分标准等关键信息，结构化呈现并智能提示风险条款；在投标评审环节，自动比对投标响应文件与招标要求，快速标出偏差项，为审核专家提供清晰参考，确保评审规范、完整、高效。',
                    img: require('@/assets/AI/招投标助手.jpg'),
                    hxgn: [
                        {
                            title: '智能招标解析',
                            text: '上传招标文件（PDF/Word），AI自动识别并提取关键信息：资质要求、技术参数、评分标准、付款方式、交付期限、违约责任等，以结构化表格呈现，支持一键导出，大幅减少人工翻阅时间。'
                        },
                        {
                            title: '风险条款提示',
                            text: '基于内置法规库和历史案例，AI分析招标文件中可能存在的风险条款，如不合理资质门槛、模糊的验收标准、单方面解约权等，并标注风险等级与建议，帮助审核人员在投标前规避潜在陷阱。'
                        },
                        {
                            title: '自动偏差比对',
                            text: '在投标评审环节，AI将投标响应文件与招标要求进行逐条语义比对，自动标记完全响应、部分响应、未响应及存在偏差的内容，生成比对报告，支持评审专家快速定位差异点，确保评审全面、客观。'
                        },
                        {
                            title: '标书辅助审核',
                            text: '结合招标解析结果与偏差比对，AI为标书编写者提供针对性建议（如“技术参数需补充证明材料”“资质文件缺失”），并生成检查清单；支持多人协同批注与版本管理，让标书审核流程更规范。'
                        }
                    ],
                    card: [
                        {
                            title: '招标文件预审',
                            text: '投标团队上传招标文件，AI自动提取关键要求和风险点，生成摘要报告，帮助团队快速决策是否参与投标，并明确重点准备方向。',
                        },
                        {
                            title: '投标方案编写',
                            text: '编写标书时，AI根据招标要求实时提示应响应的内容，并提供历史相似项目的应答范例，减少遗漏，提升响应质量。',
                        },
                        {
                            title: '投标前偏差检查',
                            text: '投标文件定稿前，AI自动与招标要求进行全量比对，输出偏差清单，提醒团队补充或修正，避免因细微偏差导致废标。',
                        },
                        {
                            title: '专家评审辅助',
                            text: '评审专家接收投标文件后，AI提前完成招标-投标比对，生成比对报告，专家可直接聚焦偏差项和重点内容，大幅缩短评审周期。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率倍增',
                            titleb: '',
                            text: '招标解析、风险识别、偏差比对全流程自动化，审核时间缩短70%以上。'
                        },
                        {
                            title: '降低风险',
                            titleb: '',
                            text: '提前发现招标文件中的隐患条款，避免中标后陷入被动；投标偏差提前修正，减少废标可能。'
                        }, {
                            title: '规范评审',
                            titleb: '',
                            text: '比对标准统一、结果可追溯，确保评审过程客观公正，满足合规要求。'
                        }, {
                            title: '知识沉淀',
                            titleb: '',
                            text: '历史招标与投标数据自动归档，形成企业知识库，新项目可快速复用经验。'
                        }, {
                            title: '协同提效',
                            titleb: '',
                            text: '支持团队在线协作、批注留痕，招投标流程更透明、可控。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs19.png'),
                        // require('@/assets/AI/gnzs20.png'),
                        // require('@/assets/AI/gnzs21.png')
                    ], gnzsb: [
                        { title: '定位异常内容', img: require('@/assets/AI/定位异常内容.png'), width: 'auto' },
                        { title: '识别异常', img: require('@/assets/AI/识别异常.png'), width: 'auto' },
                        { title: '文件解析回溯', img: require('@/assets/AI/文件解析回溯.png'), width: 'auto' },
                        { title: '智能业务流程', img: require('@/assets/AI/智能业务流程.png'), width: 'auto' }
                    ],
                },
                {
                    title: '施工技术方案智能审核平台',
                    text: 'AI学习行业规范 + 自动参数校验，让方案审查从“专家数日”到“智能分钟”',
                    info: 'AI深度解析国家、行业标准规范，对施工方案进行全方位智能评审，自动校验技术参数合规性、安全措施完整性，一键生成标准化评审报告，实现方案审查的数字化、高效化与精准化。',
                    img: require('@/assets/AI/施工技术方案智能审核平台.jpg'),
                    hxgn: [
                        {
                            title: '行业规范学习与知识库',
                            text: '系统内置国家、行业最新标准规范（建筑、市政、公路等），支持自定义上传企业标准。AI持续学习规范条文，构建结构化知识库，为智能审核提供权威依据。'
                        },
                        {
                            title: '技术参数自动校验',
                            text: '自动识别施工方案中的技术参数（如混凝土强度等级、钢筋间距、模板支撑体系尺寸），与规范要求逐项比对，生成合规性判定结果，精准标注超标或不足项。'
                        },
                        {
                            title: '安全措施完整性检查',
                            text: '基于规范对安全专项方案、应急预案、安全防护措施的要求，全面检查方案中是否包含必备的安全条款，识别缺失或不足，提示补充完善。'
                        },
                        {
                            title: '一键生成评审报告',
                            text: '审核完成后，系统自动生成结构化评审报告，包含总体结论、不符项清单、修改建议、规范依据原文。支持在线预览及PDF/Word下载，便于分发与存档。'
                        }
                    ],
                    card: [
                        {
                            title: '施工组织设计审核',
                            text: '总包单位上传施工组织设计，AI自动核对工期安排、资源配置、技术措施是否符合规范，快速输出审核意见。',
                        },
                        {
                            title: '专项施工方案审查',
                            text: '深基坑、高支模等危大工程专项方案，AI重点检查计算书参数、安全措施、监测要求，确保满足强制性条文。',
                        },
                        {
                            title: '变更方案复核',
                            text: '发生设计变更后，上传变更方案，AI快速复核新方案的技术参数和安全措施，评估合规风险。',
                        },
                        {
                            title: '现场交底准备',
                            text: '项目技术负责人准备现场交底时，通过AI提取方案中的关键控制点和安全注意事项，生成交底要点清单。',
                        }
                    ],
                    hxjz: [
                        {
                            title: '效率革命',
                            titleb: '',
                            text: '方案审查从数日缩短至分钟级，专家精力聚焦复杂问题判断。'
                        },
                        {
                            title: '降低漏检',
                            titleb: '',
                            text: 'AI不知疲倦，逐条比对，确保所有技术参数和安全条款全覆盖。'
                        }, {
                            title: '标准统一',
                            titleb: '',
                            text: '基于同一规范库，审核尺度一致，避免不同专家判断差异。'
                        }, {
                            title: '知识沉淀',
                            titleb: '',
                            text: '每次审核结果自动归档，形成企业审查案例库，持续优化标准。'
                        }, {
                            title: '合规保障',
                            titleb: '',
                            text: '及时发现合规风险，避免因方案问题导致的质量安全事故。'
                        }
                    ],
                    gnzs: [
                        // require('@/assets/AI/gnzs22.png'),
                        // require('@/assets/AI/gnzs23.png'),
                        // require('@/assets/AI/gnzs24.png')
                    ], gnzsb: [
                        { title: '技术方案审核解析', img: require('@/assets/AI/技术方案审核解析.png'), width: 'auto' },
                        { title: '审核异常追溯', img: require('@/assets/AI/审核异常追溯.png'), width: 'auto' },
                        { title: '智能业务流程', img: require('@/assets/AI/智能业务流程b.png'), width: 'auto' }
                    ]
                }
            ],
            data: {},
            height: 'calc(100vh - 80px)',

        }
    },
    created() {
        var w = window.innerWidth
        var h = window.innerHeight * 0.18 + window.innerHeight - 80
        if (w < 1550) {
            this.height = h + 'px'
        }
        // this.load()
    },
    activated() {
        this.load()
        // document.body.scrollTo({
        //     top: 0,
        //     behavior: 'smooth' // 平滑滚动
        // });
    },
    methods: {
        load() {
            ul = document.getElementById('scrollcontainer');
            var title = this.$route.query.title || this.$route.query.id
            if (title) {
                this.menu.forEach((x, i) => {
                    if (x.title == title) {
                        this.getInfo(x)
                        if (i > 7) {
                            ul.scrollBy(500, 0);
                        }
                    }
                })
            } else {
                this.getInfo(this.menu[0], 0)
            }
            ul.addEventListener('mousedown', (e) => {
                isMouseDown = true;
            })
            ul.addEventListener('mousemove', (e) => {
                if (isMouseDown) {
                    ul.scrollBy(-e.movementX, 0);
                }
            })
            ul.addEventListener('mouseup', (e) => {
                isMouseDown = false;
            })
            ul.addEventListener('mouseleave', (e) => {
                isMouseDown = false;
            })
        },
        getInfo(w, j) {
            ul = document.getElementById('scrollcontainer');
            this.index = j
            this.mindex = w.title
            this.data = w
        }
    },
}
</script>
<style>
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

:root {
    --bg: #f5f7fa;
    --fg: #1a1a2e;
    --accent: #3b82f6;
    --accent2: #8b5cf6;
    --muted: #64748b;
    --card: #ffffff;
    --border: rgba(0, 0, 0, 0.08);
}

html,
body {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    scroll-behavior: smooth;
    font-family: 'Noto Sans SC', sans-serif;
    background: var(--bg);
    color: var(--fg);
}

.slide {
    /* min-height: 100vh; */
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* padding: 3vh 3vw; */
    margin-bottom: 50px;
}

/* ── Slide 1: Maturity Levels ── */
.slide-maturity .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.header {
    margin-bottom: 40px;
}

.title {
    font-size: clamp(1.5rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
}

.title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #8b5cf6);
    border-radius: 3px;
}

.description {
    font-size: clamp(0.85rem, 1.2vw, 1rem);
    color: var(--muted);
    line-height: 1.8;
    max-width: 95%;
}

.levels-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    margin-top: 50px;
    position: relative;
}

.level-card {
    background: var(--card);
    border-radius: 16px;
    padding: 30px;
    border: 2px solid transparent;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
    position: relative;
}

.level-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12);
}

.level-1 {
    border-top: 4px solid #ef4444;
}

.level-1 .level-number {
    color: #ef4444;
}

.level-2 {
    border-top: 4px solid #f59e0b;
}

.level-2 .level-number {
    color: #f59e0b;
}

.level-3 {
    border-top: 4px solid #eab308;
}

.level-3 .level-number {
    color: #eab308;
}

.level-4 {
    border-top: 4px solid #3b82f6;
}

.level-4 .level-number {
    color: #3b82f6;
}

.level-5 {
    border-top: 4px solid #8b5cf6;
}

.level-5 .level-number {
    color: #8b5cf6;
}

.level-header {
    margin-bottom: 15px;
}

.level-number {
    font-size: 1.4rem;
    font-weight: 800;
    margin-bottom: 5px;
}

.level-title-cn {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 5px;
}

.level-title-en {
    font-size: 0.85rem;
    font-weight: 600;
    color: var(--muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.level-description {
    font-size: 0.95rem;
    color: #475569;
    line-height: 1.7;
}

.arrow {
    position: absolute;
    font-size: 1.5rem;
    color: #cbd5e1;
    top: 50%;
    transform: translateY(-50%);
}

.arrow-1 {
    right: -25px;
}

.arrow-2 {
    right: -25px;
}

.arrow-3 {
    left: -25px;
}

.arrow-4 {
    right: -25px;
}

.bottom-row {
    grid-column: span 3;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-top: 20px;
    padding: 0 15%;
}

/* ── Slide 2: Core Issues ── */
.slide-issues .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.issues-header {
    margin-bottom: 35px;
    text-align: center;
}

.issues-title {
    font-size: clamp(1.8rem, 3.5vw, 2.4rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.issues-title::before {
    content: '';
    width: 5px;
    height: 40px;
    background: linear-gradient(180deg, #ef4444, #f59e0b);
    border-radius: 3px;
}

.issues-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
}

.issues-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.issue-card {
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 12px;
    padding: 22px;
    border-left: 4px solid;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;
}

.issue-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.issue-card:nth-child(1) {
    border-left-color: #ef4444;
}

.issue-card:nth-child(2) {
    border-left-color: #f97316;
}

.issue-card:nth-child(3) {
    border-left-color: #eab308;
}

.issue-card:nth-child(4) {
    border-left-color: #22c55e;
}

.issue-card:nth-child(5) {
    border-left-color: #3b82f6;
}

.issue-card:nth-child(6) {
    border-left-color: #8b5cf6;
}

.issue-card:nth-child(7) {
    border-left-color: #ec4899;
    grid-column: span 2;
    max-width: 50%;
    margin: 0 auto;
}

.issue-header {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
}

.issue-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.9rem;
    font-weight: 700;
    color: white;
}

.issue-card:nth-child(1) .issue-icon {
    background: #ef4444;
}

.issue-card:nth-child(2) .issue-icon {
    background: #f97316;
}

.issue-card:nth-child(3) .issue-icon {
    background: #eab308;
}

.issue-card:nth-child(4) .issue-icon {
    background: #22c55e;
}

.issue-card:nth-child(5) .issue-icon {
    background: #3b82f6;
}

.issue-card:nth-child(6) .issue-icon {
    background: #8b5cf6;
}

.issue-card:nth-child(7) .issue-icon {
    background: #ec4899;
}

.issue-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e293b;
}

.issue-content {
    font-size: 0.9rem;
    color: #475569;
    line-height: 1.6;
}

.issue-content strong {
    color: #1e293b;
    font-weight: 600;
}

/* ── Title Slide ── */
.slide-title {
    background: #ffffff;
}

.title-container {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
}

.title-main {
    background: #0078d4;
    color: #ffffff;
    font-size: clamp(2.5rem, 6vw, 4.5rem);
    font-weight: 700;
    padding: 15px 50px;
    letter-spacing: 8px;
}

.title-sub {
    color: #0078d4;
    font-size: clamp(2rem, 5vw, 3.5rem);
    font-weight: 700;
    letter-spacing: 6px;
}

.title-divider {
    width: 120px;
    height: 4px;
    background: linear-gradient(90deg, #0078d4, #00a2e8);
    margin: 30px 0;
}

.title-slogan {
    font-size: clamp(1rem, 1.5vw, 1.3rem);
    color: #64748b;
    max-width: 600px;
    line-height: 1.8;
}

/* ── Solution Slide ── */
.slide-solution .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.solution-header {
    text-align: center;
    margin-bottom: 50px;
}

.solution-title {
    font-size: clamp(1.8rem, 3.5vw, 2.4rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.solution-title::before {
    content: '';
    width: 5px;
    height: 40px;
    background: linear-gradient(180deg, #10b981, #3b82f6);
    border-radius: 3px;
}

.solution-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
}

.solution-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px;
    margin-bottom: 40px;
}

.solution-card {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    padding: 30px;
    display: flex;
    gap: 20px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    transition: all 0.3s ease;
}

.solution-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.solution-card:nth-child(1) {
    border-left: 4px solid #10b981;
}

.solution-card:nth-child(2) {
    border-left: 4px solid #3b82f6;
}

.solution-card:nth-child(3) {
    border-left: 4px solid #8b5cf6;
}

.solution-card:nth-child(4) {
    border-left: 4px solid #ef4444;
}

.solution-icon {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.solution-card:nth-child(1) .solution-icon {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.solution-card:nth-child(2) .solution-icon {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
}

.solution-card:nth-child(3) .solution-icon {
    background: rgba(139, 92, 246, 0.1);
    color: #8b5cf6;
}

.solution-card:nth-child(4) .solution-icon {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

.solution-icon svg {
    width: 28px;
    height: 28px;
}

.solution-content {
    flex: 1;
}

.solution-name {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 10px;
}

.solution-desc {
    font-size: 0.95rem;
    color: #475569;
    line-height: 1.7;
}

.solution-desc strong {
    color: #1e293b;
    font-weight: 600;
}

.solution-summary {
    text-align: center;
    padding: 30px;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border-radius: 12px;
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.summary-text {
    font-size: clamp(1rem, 1.5vw, 1.2rem);
    color: #475569;
    line-height: 1.8;
}

.summary-text strong {
    color: #1e293b;
    font-size: 1.3rem;
    font-weight: 700;
}

/* ── Architecture Slide ── */
.slide-architecture .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.architecture-header {
    text-align: center;
    margin-bottom: 30px;
}

.architecture-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.architecture-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #8b5cf6);
    border-radius: 3px;
}

.architecture-subtitle {
    font-size: clamp(0.85rem, 1.1vw, 1rem);
    color: var(--muted);
    line-height: 1.5;
}

.architecture-content {
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 30px;
    align-items: start;
}

.architecture-diagram {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    padding: 20px;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.architecture-img {
    max-width: 100%;
    max-height: 520px;
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    object-fit: contain;
}

.architecture-legend {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.legend-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    padding-bottom: 10px;
    border-bottom: 2px solid #e2e8f0;
}

.legend-items {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.legend-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px;
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 10px;
    border-left: 3px solid #3b82f6;
}

.legend-color {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    flex-shrink: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
}

.legend-text {
    font-size: 0.85rem;
    color: #475569;
    line-height: 1.5;
}

.legend-text strong {
    color: #1e293b;
    font-weight: 600;
}

.architecture-highlights {
    background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
    border-radius: 12px;
    padding: 16px;
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.highlight-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 12px;
}

.highlight-list {
    display: grid;
    grid-template-columns: 1fr;
    gap: 8px;
}

.highlight-item {
    font-size: 0.8rem;
    color: #475569;
    padding: 6px 10px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.highlight-item:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateX(3px);
}

/* ── Enterprise Claw Slide ── */
.slide-claw .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.claw-header {
    text-align: center;
    margin-bottom: 35px;
}

.claw-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.claw-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #8b5cf6);
    border-radius: 3px;
}

.claw-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
}

.claw-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 25px;
    align-items: start;
}

.claw-left-column {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.claw-right-column {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.claw-right-column .claw-card {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.claw-card {
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 16px;
    padding: 25px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.claw-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.claw-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}

.claw-icon {
    width: 42px;
    height: 42px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    flex-shrink: 0;
}

.claw-card-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1e293b;
}

.claw-card-desc {
    font-size: 0.85rem;
    color: #64748b;
    line-height: 1.5;
    margin-bottom: 15px;
}

/* Flow Steps */
.claw-flow {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.flow-step {
    padding: 6px 10px;
    background: linear-gradient(135deg, #3b82f6, #6366f1);
    color: white;
    border-radius: 6px;
    font-size: 0.75rem;
    font-weight: 600;
    white-space: nowrap;
}

.flow-arrow {
    color: #94a3b8;
    font-size: 0.9rem;
    font-weight: 700;
}

/* Flow Branch */
.claw-flow-branch {
    margin-top: 8px;
}

.flow-branch-line {
    display: flex;
    justify-content: center;
    margin-bottom: 8px;
}

.branch-arrow.down {
    color: #94a3b8;
    font-size: 1rem;
    font-weight: 700;
}

.flow-branch-options {
    display: flex;
    gap: 20px;
    justify-content: center;
    flex-wrap: wrap;
}

.branch-option {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
}

.flow-step.step-clarify {
    background: linear-gradient(135deg, #f59e0b, #f97316);
}

.flow-step.step-output {
    background: linear-gradient(135deg, #22c55e, #10b981);
}

.branch-desc {
    font-size: 0.7rem;
    color: #94a3b8;
    text-align: center;
}

/* Loop Back */
.claw-loop-back {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 8px;
    padding: 6px 10px;
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(249, 115, 22, 0.1));
    border-radius: 6px;
    border: 1px dashed rgba(245, 158, 11, 0.4);
    position: relative;
}

.loop-arrow {
    font-size: 1rem;
    color: #f59e0b;
    font-weight: 700;
}

.loop-text {
    font-size: 0.7rem;
    color: #d97706;
    font-weight: 600;
}

/* Loop Connection Lines */
.claw-flow-wrapper {
    position: relative;
}

.claw-flow-main {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
    position: relative;
}

.flow-step-wrapper {
    position: relative;
}

.branch-option {
    position: relative;
}

/* Loop Connection Line */
.loop-connection {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 1;
}

.loop-connection svg {
    width: 100%;
    height: 100%;
}

.clarify-option {
    position: relative;
}

/* Loop Back Connection Line using pure CSS */
.loop-back-line {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -50px;
    height: 50px;
    pointer-events: none;
    z-index: 1;
}

.loop-back-line::before {
    content: '';
    position: absolute;
    left: 15px;
    bottom: 0;
    width: calc(100% - 30px);
    height: 40px;
    border-left: 2px dashed #f59e0b;
    border-bottom: 2px dashed #f59e0b;
    border-radius: 0 0 0 18px;
}

.loop-back-line::after {
    content: '';
    position: absolute;
    left: 9px;
    bottom: 35px;
    width: 0;
    height: 0;
    border-top: 4px solid transparent;
    border-bottom: 4px solid transparent;
    border-right: 6px solid #f59e0b;
}

/* Security Layers */
.claw-security-layers {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.sec-layer {
    flex: 1;
    min-width: 80px;
    padding: 12px 8px;
    border-radius: 10px;
    text-align: center;
    border: 1px solid;
}

.layer-input {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.1), rgba(239, 68, 68, 0.05));
    border-color: rgba(239, 68, 68, 0.3);
}

.layer-ai {
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(245, 158, 11, 0.05));
    border-color: rgba(245, 158, 11, 0.3);
}

.layer-sandbox {
    background: linear-gradient(135deg, rgba(59, 130, 246, 0.1), rgba(59, 130, 246, 0.05));
    border-color: rgba(59, 130, 246, 0.3);
}

.layer-output {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.1), rgba(34, 197, 94, 0.05));
    border-color: rgba(34, 197, 94, 0.3);
}

.sec-icon {
    font-size: 1.3rem;
    margin-bottom: 6px;
}

.sec-name {
    font-size: 0.7rem;
    font-weight: 600;
    color: #475569;
}

/* Fault Features */
.claw-fault-features {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
}

.fault-feature {
    flex: 1;
    min-width: 100px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 10px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 8px;
}

.fault-icon {
    font-size: 1.2rem;
}

.fault-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: #1e293b;
}

.fault-detail {
    font-size: 0.7rem;
    color: #64748b;
}

/* Memory Layers */
.claw-memory-layers {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.mem-layer {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid;
}

.mem-long {
    background: linear-gradient(135deg, rgba(34, 197, 94, 0.1), rgba(34, 197, 94, 0.05));
    border-color: rgba(34, 197, 94, 0.3);
}

.mem-medium {
    background: linear-gradient(135deg, rgba(6, 182, 212, 0.1), rgba(6, 182, 212, 0.05));
    border-color: rgba(6, 182, 212, 0.3);
}

.mem-short {
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(245, 158, 11, 0.05));
    border-color: rgba(245, 158, 11, 0.3);
}

.mem-badge {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 0.65rem;
    font-weight: 700;
    color: white;
    white-space: nowrap;
}

.mem-long .mem-badge {
    background: #22c55e;
}

.mem-medium .mem-badge {
    background: #06b6d4;
}

.mem-short .mem-badge {
    background: #f59e0b;
}

.mem-title {
    font-size: 0.8rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 4px;
}

.mem-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

.mem-tags span {
    padding: 2px 6px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 3px;
    font-size: 0.65rem;
    color: #64748b;
}

.claw-summary {
    margin-top: 30px;
    text-align: center;
    padding: 20px;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border-radius: 12px;
    border: 1px solid rgba(59, 130, 246, 0.15);
}

.claw-summary-text {
    font-size: 1rem;
    color: #475569;
    line-height: 1.6;
}

.claw-summary-text strong {
    color: #1e293b;
    font-size: 1.15rem;
    font-weight: 700;
}

/* ── Platform vs WorkBuddy Slide ── */
.slide-positioning .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.positioning-header {
    text-align: center;
    margin-bottom: 36px;
}

.positioning-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.positioning-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #0078d4, #f59e0b);
    border-radius: 3px;
}

.positioning-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.positioning-compare {
    display: grid;
    grid-template-columns: 1fr 80px 1fr;
    gap: 0;
    align-items: stretch;
    margin-bottom: 30px;
}

.positioning-side {
    border-radius: 20px;
    padding: 32px 28px;
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.positioning-side.tob {
    background: linear-gradient(135deg, #eef6ff 0%, #dbeafe 50%, #e0f2fe 100%);
    border: 2px solid rgba(0, 120, 212, 0.2);
    position: relative;
    overflow: hidden;
}

.positioning-side.tob::before {
    content: '';
    position: absolute;
    top: -40px;
    right: -40px;
    width: 120px;
    height: 120px;
    background: radial-gradient(circle, rgba(0, 120, 212, 0.08) 0%, transparent 70%);
    border-radius: 50%;
}

.positioning-side.toc {
    background: linear-gradient(135deg, #fff7ed 0%, #ffedd5 50%, #fef3c7 100%);
    border: 2px solid rgba(245, 158, 11, 0.2);
    position: relative;
    overflow: hidden;
}

.positioning-side.toc::before {
    content: '';
    position: absolute;
    top: -40px;
    left: -40px;
    width: 120px;
    height: 120px;
    background: radial-gradient(circle, rgba(245, 158, 11, 0.08) 0%, transparent 70%);
    border-radius: 50%;
}

.positioning-bridge {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
}

.bridge-vs {
    width: 52px;
    height: 52px;
    border-radius: 50%;
    background: linear-gradient(135deg, #ffffff, #f1f5f9);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.85rem;
    font-weight: 800;
    color: #64748b;
    border: 2px solid #e2e8f0;
}

.bridge-line {
    width: 2px;
    flex: 1;
    min-height: 60px;
    background: repeating-linear-gradient(180deg, #cbd5e1 0, #cbd5e1 6px, transparent 6px, transparent 12px);
}

.positioning-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 6px 16px;
    border-radius: 999px;
    font-size: 0.8rem;
    font-weight: 700;
    letter-spacing: 0.5px;
    width: fit-content;
}

.positioning-side.tob .positioning-badge {
    background: linear-gradient(135deg, #0078d4, #00a2e8);
    color: #ffffff;
}

.positioning-side.toc .positioning-badge {
    background: linear-gradient(135deg, #f59e0b, #f97316);
    color: #ffffff;
}

.positioning-product-name {
    font-size: 1.6rem;
    font-weight: 800;
    margin-bottom: 4px;
    position: relative;
    z-index: 1;
}

.positioning-side.tob .positioning-product-name {
    color: #0078d4;
}

.positioning-side.toc .positioning-product-name {
    color: #d97706;
}

.positioning-tagline {
    font-size: 0.9rem;
    color: #475569;
    line-height: 1.5;
    margin-bottom: 8px;
    position: relative;
    z-index: 1;
}

.positioning-features {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.pos-feature {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px;
    border-radius: 12px;
    transition: all 0.3s ease;
}

.positioning-side.tob .pos-feature {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(0, 120, 212, 0.1);
}

.positioning-side.tob .pos-feature:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(0, 120, 212, 0.1);
}

.positioning-side.toc .pos-feature {
    background: rgba(255, 255, 255, 0.7);
    border: 1px solid rgba(245, 158, 11, 0.1);
}

.positioning-side.toc .pos-feature:hover {
    background: rgba(255, 255, 255, 0.95);
    transform: translateX(4px);
    box-shadow: 0 4px 12px rgba(245, 158, 11, 0.1);
}

.pos-feature-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.1rem;
    flex-shrink: 0;
}

.positioning-side.tob .pos-feature-icon {
    background: linear-gradient(135deg, rgba(0, 120, 212, 0.15), rgba(0, 162, 232, 0.1));
}

.positioning-side.toc .pos-feature-icon {
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.15), rgba(249, 115, 22, 0.1));
}

.pos-feature-text {
    flex: 1;
}

.pos-feature-name {
    font-size: 0.9rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 3px;
}

.pos-feature-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.positioning-highlight {
    padding: 20px 24px;
    border-radius: 14px;
    margin-top: 4px;
    position: relative;
    z-index: 1;
}

.positioning-side.tob .positioning-highlight {
    background: linear-gradient(135deg, rgba(0, 120, 212, 0.1), rgba(0, 162, 232, 0.06));
    border: 1px dashed rgba(0, 120, 212, 0.3);
}

.positioning-side.toc .positioning-highlight {
    background: linear-gradient(135deg, rgba(245, 158, 11, 0.1), rgba(249, 115, 22, 0.06));
    border: 1px dashed rgba(245, 158, 11, 0.3);
}

.positioning-highlight-title {
    font-size: 0.85rem;
    font-weight: 700;
    margin-bottom: 6px;
}

.positioning-side.tob .positioning-highlight-title {
    color: #0078d4;
}

.positioning-side.toc .positioning-highlight-title {
    color: #d97706;
}

.positioning-highlight-text {
    font-size: 0.8rem;
    color: #475569;
    line-height: 1.6;
}

.positioning-summary {
    padding: 20px 24px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(0, 120, 212, 0.06), rgba(245, 158, 11, 0.06));
    text-align: center;
    color: #334155;
    font-size: 0.95rem;
    line-height: 1.7;
}

.positioning-summary strong {
    color: #1e293b;
    font-weight: 700;
}

.positioning-summary .highlight-tob {
    color: #0078d4;
    font-weight: 700;
}

.positioning-summary .highlight-toc {
    color: #d97706;
    font-weight: 700;
}

@media (max-width: 1200px) {
    .positioning-compare {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    .positioning-bridge {
        flex-direction: row;
        padding: 10px 0;
    }

    .bridge-line {
        width: auto;
        height: 2px;
        min-height: auto;
        min-width: 60px;
        background: repeating-linear-gradient(90deg, #cbd5e1 0, #cbd5e1 6px, transparent 6px, transparent 12px);
    }
}

/* ── Platform Features Slide ── */
.slide-platform .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.platform-header {
    text-align: center;
    margin-bottom: 40px;
}

.platform-title {
    font-size: clamp(1.8rem, 3.5vw, 2.4rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 12px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.platform-title::before {
    content: '';
    width: 5px;
    height: 40px;
    background: linear-gradient(180deg, #0078d4, #00a2e8);
    border-radius: 3px;
}

.platform-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
    max-width: 800px;
    margin: 0 auto;
    line-height: 1.6;
}

.platform-content {
    display: grid;
    grid-template-columns: 1.4fr 1fr;
    gap: 30px;
    align-items: start;
}

.platform-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    padding: 15px;
    border: 1px solid #e2e8f0;
    min-height: 550px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.screenshot-img {
    max-width: 100%;
    /* max-height: 520px; */
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    object-fit: contain;
}

.platform-features {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.feature-category {
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 10px;
    padding: 14px 16px;
    border-left: 3px solid #0078d4;
}

.feature-category:nth-child(2) {
    border-left-color: #10b981;
}

.feature-category:nth-child(3) {
    border-left-color: #8b5cf6;
}

.category-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.feature-list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
}

.feature-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 6px 8px;
    background: rgba(255, 255, 255, 0.6);
    border-radius: 6px;
    transition: all 0.2s ease;
}

.feature-item:hover {
    background: rgba(255, 255, 255, 0.9);
    transform: translateX(3px);
}

.feature-icon {
    font-size: 1.1rem;
    line-height: 1;
}

.feature-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 1px;
}

.feature-desc {
    font-size: 0.7rem;
    color: #64748b;
    line-height: 1.3;
}

/* Responsive */
@media (max-width: 1200px) {

    .slide-maturity .container,
    .slide-issues .container {
        padding: 40px;
    }

    .levels-container {
        grid-template-columns: repeat(2, 1fr);
    }

    .bottom-row {
        grid-column: span 2;
        padding: 0;
    }

    .arrow {
        display: none;
    }

    .issues-grid {
        grid-template-columns: 1fr;
    }

    .issue-card:nth-child(7) {
        grid-column: span 1;
        max-width: 100%;
    }

    .title-main {
        padding: 12px 30px;
        letter-spacing: 4px;
    }
}

@media (max-width: 768px) {

    .slide-maturity .container,
    .slide-issues .container {
        padding: 25px 20px;
    }

    .title,
    .issues-title {
        font-size: 1.4rem;
    }

    .levels-container {
        grid-template-columns: 1fr;
    }

    .bottom-row {
        grid-column: span 1;
        grid-template-columns: 1fr;
    }

    .title-main {
        padding: 10px 20px;
        letter-spacing: 2px;
    }

    .title-sub {
        letter-spacing: 3px;
    }

    .solution-grid {
        grid-template-columns: 1fr;
    }

    .solution-card {
        flex-direction: column;
        text-align: center;
    }

    .slide-solution .container {
        padding: 30px 20px;
    }

    .platform-content {
        grid-template-columns: 1fr;
    }

    .platform-screenshot {
        min-height: 300px;
        order: 2;
    }

    .screenshot-img {
        max-height: 280px;
    }

    .platform-features {
        order: 1;
        gap: 10px;
    }

    .feature-list {
        grid-template-columns: repeat(2, 1fr);
    }

    .slide-platform .container {
        padding: 30px 20px;
    }

    .architecture-content {
        grid-template-columns: 1fr;
    }

    .architecture-diagram {
        padding: 15px;
    }

    .architecture-img {
        max-height: 350px;
    }

    .architecture-legend {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 15px;
    }

    .legend-items {
        flex: 1;
        min-width: 200px;
    }

    .architecture-highlights {
        flex: 1;
        min-width: 200px;
    }

    .slide-architecture .container {
        padding: 30px 20px;
    }

    .slide-maturity .container,
    .slide-issues .container {
        padding: 30px 20px;
    }

    .claw-content {
        grid-template-columns: 1fr;
    }

    .claw-left-column,
    .claw-right-column {
        width: 100%;
    }

    .claw-card {
        padding: 20px;
    }

    .claw-flow {
        justify-content: center;
    }

    .flow-step {
        font-size: 0.7rem;
        padding: 5px 8px;
    }

    .sec-layer {
        min-width: 70px;
        padding: 10px 6px;
    }

    .sec-icon {
        font-size: 1.1rem;
    }

    .sec-name {
        font-size: 0.65rem;
    }

    .fault-feature {
        min-width: 90px;
    }

    .slide-claw .container {
        padding: 30px 20px;
    }
}

/* ── API Integration Slide ── */
.slide-api-integration .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.api-header {
    text-align: center;
    margin-bottom: 26px;
}

.api-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.api-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #14b8a6);
    border-radius: 3px;
}

.api-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.api-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.api-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.api-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #ecfeff 100%);
    border-color: rgba(20, 184, 166, 0.12);
}

.api-pillar:nth-child(3) {
    background: linear-gradient(135deg, #f8fafc 0%, #edfdf5 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.api-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.api-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.api-content {
    /* display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 24px;
    align-items: start; */
}

.api-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 18px;
    padding: 14px;
    border: 1px solid #e2e8f0;
}

.api-image {
    width: 100%;
    /* height: 420px; */
    display: block;
    object-fit: contain;
    object-position: center;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #ffffff;
}

.api-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.api-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 18px;
}

.api-card:first-child {
    border-left: 4px solid #3b82f6;
}

.api-card:nth-child(2) {
    border-left: 4px solid #14b8a6;
}

.api-card:nth-child(3) {
    border-left: 4px solid #10b981;
}

.api-card-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.api-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.6;
}

.api-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.api-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.api-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.08), rgba(20, 184, 166, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .api-pillars,
    .api-content {
        grid-template-columns: 1fr;
    }

    .api-image {
        height: 340px;
    }
}

/* ── Permission Management Slide ── */
.slide-permission-management .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.permission-header {
    text-align: center;
    margin-bottom: 26px;
}

.permission-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.permission-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #8b5cf6, #3b82f6);
    border-radius: 3px;
}

.permission-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.permission-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.permission-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #f4f0ff 100%);
    border: 1px solid rgba(139, 92, 246, 0.12);
}

.permission-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
    border-color: rgba(59, 130, 246, 0.1);
}

.permission-pillar:nth-child(3) {
    background: linear-gradient(135deg, #f8fafc 0%, #edfdf5 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.permission-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.permission-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.permission-content {
    /* display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 24px;
    align-items: start; */
}

.permission-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 18px;
    padding: 14px;
    border: 1px solid #e2e8f0;
}

.permission-image {
    width: 100%;
    /* height: 420px; */
    display: block;
    object-fit: contain;
    object-position: center;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #ffffff;
}

.permission-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.permission-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 18px;
}

.permission-card:first-child {
    border-left: 4px solid #8b5cf6;
}

.permission-card:nth-child(2) {
    border-left: 4px solid #3b82f6;
}

.permission-card:nth-child(3) {
    border-left: 4px solid #10b981;
}

.permission-card-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.permission-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.6;
}

.permission-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.permission-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.permission-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(139, 92, 246, 0.08), rgba(59, 130, 246, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .permission-pillars,
    .permission-content {
        grid-template-columns: 1fr;
    }

    .permission-image {
        height: 340px;
    }
}

/* ── Task Management Slide ── */
.slide-task-management .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.task-header {
    text-align: center;
    margin-bottom: 26px;
}

.task-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.task-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #f59e0b);
    border-radius: 3px;
}

.task-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.task-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.task-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.task-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #fff7ed 100%);
    border-color: rgba(245, 158, 11, 0.12);
}

.task-pillar:nth-child(3) {
    background: linear-gradient(135deg, #f8fafc 0%, #edfdf5 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.task-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.task-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.task-content {
    /* display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 24px;
    align-items: start; */
}

.task-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 18px;
    padding: 14px;
    border: 1px solid #e2e8f0;
}

.task-image {
    width: 100%;
    /* height: 430px; */
    display: block;
    object-fit: contain;
    object-position: center;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #ffffff;
}

.task-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.task-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 18px;
}

.task-card:first-child {
    border-left: 4px solid #3b82f6;
}

.task-card:nth-child(2) {
    border-left: 4px solid #f59e0b;
}

.task-card:nth-child(3) {
    border-left: 4px solid #10b981;
}

.task-card-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.task-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.6;
}

.task-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.task-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.task-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.08), rgba(245, 158, 11, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .task-pillars,
    .task-content {
        grid-template-columns: 1fr;
    }

    .task-image {
        height: 340px;
    }
}

/* ── Agent Orchestration Slide ── */
.slide-orchestration .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.orchestration-header {
    text-align: center;
    margin-bottom: 30px;
}

.orchestration-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.orchestration-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #8b5cf6, #ec4899);
    border-radius: 3px;
}

.orchestration-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
}

.orchestration-content {
    /* display: grid;
    grid-template-columns: 1.5fr 1fr;
    gap: 30px;
    align-items: start; */
}

.orchestration-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    padding: 15px;
    border: 1px solid #e2e8f0;
    min-height: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.orchestration-img {
    max-width: 100%;
    /* max-height: 490px; */
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    object-fit: contain;
}

.orchestration-features {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.orch-category {
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 12px;
    padding: 14px 16px;
    border-left: 3px solid #8b5cf6;
    transition: all 0.3s ease;
}

.orch-category:hover {
    transform: translateX(3px);
    box-shadow: 0 4px 12px rgba(139, 92, 246, 0.1);
}

.orch-category:nth-child(2) {
    border-left-color: #3b82f6;
}

.orch-category:nth-child(3) {
    border-left-color: #10b981;
}

.orch-category:nth-child(4) {
    border-left-color: #f59e0b;
}

.orch-category:nth-child(5) {
    border-left-color: #ec4899;
}

.orch-category:nth-child(6) {
    border-left-color: #06b6d4;
}

.orch-category-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.orch-category-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.5;
}

.orch-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.orch-tag {
    padding: 3px 8px;
    background: rgba(139, 92, 246, 0.1);
    border-radius: 4px;
    font-size: 0.7rem;
    color: #8b5cf6;
    font-weight: 500;
}

.orch-category:nth-child(2) .orch-tag {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
}

.orch-category:nth-child(3) .orch-tag {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.orch-category:nth-child(4) .orch-tag {
    background: rgba(245, 158, 11, 0.1);
    color: #f59e0b;
}

.orch-category:nth-child(5) .orch-tag {
    background: rgba(236, 72, 153, 0.1);
    color: #ec4899;
}

.orch-category:nth-child(6) .orch-tag {
    background: rgba(6, 182, 212, 0.1);
    color: #06b6d4;
}

/* 底部两个模块的样式 */
.orchestration-bottom {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 20px;
}

.orch-bottom-card {
    margin: 0;
}

.orch-bottom-card:nth-child(1) {
    border-left-color: #ec4899;
}

.orch-bottom-card:nth-child(2) {
    border-left-color: #06b6d4;
}

.orch-bottom-card:nth-child(1) .orch-tag {
    background: rgba(236, 72, 153, 0.1);
    color: #ec4899;
}

.orch-bottom-card:nth-child(2) .orch-tag {
    background: rgba(6, 182, 212, 0.1);
    color: #06b6d4;
}

@media (max-width: 1200px) {
    .orchestration-content {
        grid-template-columns: 1fr;
    }

    .orchestration-screenshot {
        min-height: 350px;
        order: 2;
    }

    .orchestration-img {
        max-height: 320px;
    }

    .orchestration-features {
        order: 1;
    }

    .orchestration-bottom {
        grid-template-columns: 1fr;
    }
}

/* ── Agent Paradigms Slide ── */
.slide-paradigms .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.paradigm-header {
    text-align: center;
    margin-bottom: 28px;
}

.paradigm-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.paradigm-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #f59e0b);
    border-radius: 3px;
}

.paradigm-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.paradigm-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    align-items: stretch;
}

.paradigm-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 20px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 24px;
    display: flex;
    flex-direction: column;
    gap: 18px;
}

.paradigm-card.skill {
    border-top: 4px solid #3b82f6;
}

.paradigm-card.workflow {
    border-top: 4px solid #f59e0b;
}

.paradigm-card-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
}

.paradigm-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 0.72rem;
    font-weight: 600;
    margin-bottom: 10px;
}

.paradigm-card.skill .paradigm-badge {
    background: rgba(59, 130, 246, 0.12);
    color: #3b82f6;
}

.paradigm-card.workflow .paradigm-badge {
    background: rgba(245, 158, 11, 0.14);
    color: #d97706;
}

.paradigm-card-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.paradigm-card-desc {
    font-size: 0.85rem;
    line-height: 1.65;
    color: #64748b;
}

.paradigm-icon {
    width: 52px;
    height: 52px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
    flex-shrink: 0;
}

.paradigm-card.skill .paradigm-icon {
    background: linear-gradient(135deg, #3b82f6, #6366f1);
}

.paradigm-card.workflow .paradigm-icon {
    background: linear-gradient(135deg, #f59e0b, #f97316);
}

.paradigm-section {
    background: rgba(248, 250, 252, 0.9);
    border: 1px solid rgba(148, 163, 184, 0.12);
    border-radius: 14px;
    padding: 16px;
}

.paradigm-section-title {
    font-size: 0.86rem;
    font-weight: 700;
    color: #334155;
    margin-bottom: 10px;
}

.paradigm-flow {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
}

.paradigm-step {
    padding: 6px 10px;
    border-radius: 999px;
    font-size: 0.74rem;
    font-weight: 600;
    color: #475569;
    background: #ffffff;
    border: 1px solid rgba(148, 163, 184, 0.2);
}

.paradigm-arrow {
    color: #94a3b8;
    font-size: 0.9rem;
    font-weight: 700;
}

.paradigm-list {
    display: grid;
    gap: 10px;
}

.paradigm-item {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    font-size: 0.8rem;
    line-height: 1.55;
    color: #475569;
}

.paradigm-item strong {
    color: #1e293b;
}

.paradigm-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    margin-top: 6px;
    flex-shrink: 0;
}

.paradigm-card.skill .paradigm-dot {
    background: #3b82f6;
}

.paradigm-card.workflow .paradigm-dot {
    background: #f59e0b;
}

.paradigm-summary {
    margin-top: 22px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.08), rgba(245, 158, 11, 0.08));
    text-align: center;
    font-size: 0.9rem;
    color: #334155;
    line-height: 1.6;
}

@media (max-width: 1200px) {
    .paradigm-grid {
        grid-template-columns: 1fr;
    }
}

/* ── Skill Intro Slide ── */
.slide-skill-intro .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.skill-intro-header {
    text-align: center;
    margin-bottom: 24px;
}

.skill-intro-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.skill-intro-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #8b5cf6);
    border-radius: 3px;
}

.skill-intro-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.skill-intro-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.skill-intro-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.skill-intro-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #f4f0ff 100%);
    border-color: rgba(139, 92, 246, 0.12);
}

.skill-intro-pillar:nth-child(3) {
    background: linear-gradient(135deg, #f8fafc 0%, #edfdf5 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.skill-intro-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.skill-intro-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.skill-intro-content {
    /* display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 24px;
    align-items: start; */
}

.skill-intro-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 18px;
    padding: 14px;
    border: 1px solid #e2e8f0;
}

.skill-intro-image {
    width: 100%;
    /* height: 500px; */
    display: block;
    object-fit: contain;
    object-position: top center;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #ffffff;
}

.skill-intro-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.skill-intro-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 18px;
}

.skill-intro-card:first-child {
    border-left: 4px solid #3b82f6;
}

.skill-intro-card:nth-child(2) {
    border-left: 4px solid #8b5cf6;
}

.skill-intro-card:nth-child(3) {
    border-left: 4px solid #10b981;
}

.skill-intro-card-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.skill-intro-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.6;
}

.skill-source-tags,
.skill-effect-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.skill-source-tag,
.skill-effect-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.skill-intro-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.08), rgba(139, 92, 246, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .skill-intro-pillars,
    .skill-intro-content {
        grid-template-columns: 1fr;
    }

    .skill-intro-image {
        height: 360px;
    }
}

/* ── Plugin Intro Slide ── */
.slide-plugin-intro .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.plugin-intro-header {
    text-align: center;
    margin-bottom: 24px;
}

.plugin-intro-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.plugin-intro-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #8b5cf6, #3b82f6);
    border-radius: 3px;
}

.plugin-intro-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.plugin-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.plugin-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #f4f0ff 100%);
    border: 1px solid rgba(139, 92, 246, 0.12);
}

.plugin-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
    border-color: rgba(59, 130, 246, 0.1);
}

.plugin-pillar:nth-child(3) {
    background: linear-gradient(135deg, #f8fafc 0%, #edfdf5 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.plugin-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.plugin-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.plugin-intro-content {
    /* display: grid;
    grid-template-columns: 1.15fr 1fr;
    gap: 24px;
    align-items: start; */
}

.plugin-intro-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 18px;
    padding: 14px;
    border: 1px solid #e2e8f0;
}

.plugin-intro-image {
    width: 100%;
    /* height: 500px; */
    display: block;
    object-fit: contain;
    object-position: top center;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #ffffff;
}

.plugin-intro-right {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.plugin-intro-card {
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 16px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    padding: 18px;
}

.plugin-intro-card:first-child {
    border-left: 4px solid #8b5cf6;
}

.plugin-intro-card:nth-child(2) {
    border-left: 4px solid #3b82f6;
}

.plugin-intro-card:nth-child(3) {
    border-left: 4px solid #10b981;
}

.plugin-intro-card-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.plugin-intro-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.6;
}

.plugin-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.plugin-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.plugin-intro-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(139, 92, 246, 0.08), rgba(59, 130, 246, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .plugin-pillars,
    .plugin-intro-content {
        grid-template-columns: 1fr;
    }

    .plugin-intro-image {
        height: 360px;
    }
}

/* ── Knowledge Base Showcase Slide ── */
.slide-kb-showcase .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.kb-showcase-header {
    text-align: center;
    margin-bottom: 24px;
}

.kb-showcase-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.kb-showcase-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #10b981);
    border-radius: 3px;
}

.kb-showcase-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.kb-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.kb-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #eef6ff 100%);
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.kb-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #edfdf5 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.kb-pillar:nth-child(3) {
    background: linear-gradient(135deg, #faf5ff 0%, #f5f3ff 100%);
    border-color: rgba(139, 92, 246, 0.1);
}

.kb-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.kb-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.kb-showcase-grid {
    /* display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px; */
}

.kb-card {
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 18px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
}

.kb-card:first-child {
    border-top: 4px solid #3b82f6;
}

.kb-card:last-child {
    border-top: 4px solid #10b981;
}

.kb-card-body {
    padding: 18px 18px 12px;
}

.kb-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    font-size: 0.72rem;
    font-weight: 600;
    margin-bottom: 10px;
}

.kb-card:last-child .kb-label {
    background: rgba(16, 185, 129, 0.12);
    color: #10b981;
}

.kb-card-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.kb-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.55;
    min-height: 72px;
}

.kb-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.kb-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.kb-image-wrap {
    margin-top: auto;
    padding: 0 14px 14px;
}

.kb-image {
    width: 100%;
    /* height: 320px; */
    display: block;
    object-fit: contain;
    object-position: center;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #f8fafc;
}

.kb-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.08), rgba(16, 185, 129, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .kb-pillars,
    .kb-showcase-grid {
        grid-template-columns: 1fr;
    }

    .kb-card-desc {
        min-height: auto;
    }
}

/* ── AIPas Agent Showcase Slide ── */
.slide-agent-showcase .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 36px 40px;
}

.agent-showcase-header {
    text-align: center;
    margin-bottom: 24px;
}

.agent-showcase-title {
    font-size: clamp(1.7rem, 3vw, 2.3rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.agent-showcase-title::before {
    content: '';
    width: 5px;
    height: 38px;
    background: linear-gradient(180deg, #3b82f6, #8b5cf6);
    border-radius: 3px;
}

.agent-showcase-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.05rem);
    color: var(--muted);
}

.agent-showcase-pillars {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
    margin-bottom: 24px;
}

.agent-pillar {
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, #f8fafc 0%, #eef4ff 100%);
    border: 1px solid rgba(59, 130, 246, 0.1);
}

.agent-pillar:nth-child(2) {
    background: linear-gradient(135deg, #f8fafc 0%, #eefbf6 100%);
    border-color: rgba(16, 185, 129, 0.1);
}

.agent-pillar:nth-child(3) {
    background: linear-gradient(135deg, #faf5ff 0%, #f5f3ff 100%);
    border-color: rgba(139, 92, 246, 0.12);
}

.agent-pillar-title {
    font-size: 0.95rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.agent-pillar-desc {
    font-size: 0.78rem;
    color: #64748b;
    line-height: 1.5;
}

.agent-showcase-grid {
    /* display: grid; */
    /* grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px; */
}

.agent-showcase-card {
    display: flex;
    flex-direction: column;
    background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
    border-radius: 18px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    overflow: hidden;
    min-height: 100%;
}

.agent-showcase-card:nth-child(1) {
    border-top: 4px solid #3b82f6;
}

.agent-showcase-card:nth-child(2) {
    border-top: 4px solid #10b981;
}

.agent-showcase-body {
    padding: 18px 18px 12px;
}

.agent-showcase-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
    font-size: 0.72rem;
    font-weight: 600;
    margin-bottom: 10px;
}

.agent-showcase-card:nth-child(2) .agent-showcase-label {
    background: rgba(16, 185, 129, 0.12);
    color: #10b981;
}

.agent-showcase-card-title {
    font-size: 1.05rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 8px;
}

.agent-showcase-card-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.55;
    min-height: 50px;
}

.agent-showcase-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.agent-showcase-tag {
    padding: 4px 10px;
    border-radius: 999px;
    background: rgba(148, 163, 184, 0.12);
    color: #475569;
    font-size: 0.72rem;
    font-weight: 500;
}

.agent-showcase-image-wrap {
    margin-top: auto;
    padding: 0 14px 14px;
}

.agent-showcase-image {
    width: 100%;
    /* height: 320px; */
    display: block;
    object-fit: contain;
    object-position: center;
    border-radius: 14px;
    border: 1px solid #e2e8f0;
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.08);
    background: #f8fafc;
}

.agent-showcase-summary {
    margin-top: 20px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(90deg, rgba(59, 130, 246, 0.08), rgba(139, 92, 246, 0.08));
    text-align: center;
    color: #334155;
    font-size: 0.92rem;
    line-height: 1.6;
}

@media (max-width: 1200px) {

    .agent-showcase-pillars,
    .agent-showcase-grid {
        grid-template-columns: 1fr;
    }

    .agent-showcase-card-desc {
        min-height: auto;
    }
}

/* ── Agent Center Slide ── */
.slide-agent-center .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.agent-center-header {
    text-align: center;
    margin-bottom: 30px;
}

.agent-center-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.agent-center-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #3b82f6, #10b981);
    border-radius: 3px;
}

.agent-center-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
}

.agent-center-content {
    /* display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 30px; */
}

.agent-mode-card {
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 16px;
    padding: 24px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.agent-mode-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08);
}

.agent-mode-card:first-child {
    border-top: 3px solid #3b82f6;
}

.agent-mode-card:last-child {
    border-top: 3px solid #10b981;
}

.agent-mode-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 16px;
}

.agent-mode-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.5rem;
}

.agent-mode-card:first-child .agent-mode-icon {
    background: linear-gradient(135deg, #3b82f6, #6366f1);
}

.agent-mode-card:last-child .agent-mode-icon {
    background: linear-gradient(135deg, #10b981, #22c55e);
}

.agent-mode-title {
    font-size: 1.2rem;
    font-weight: 700;
    color: #1e293b;
}

.agent-mode-desc {
    font-size: 0.85rem;
    color: #64748b;
    line-height: 1.6;
    margin-bottom: 16px;
}

.agent-mode-features {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 20px;
}

.agent-mode-tag {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 0.75rem;
    font-weight: 500;
}

.agent-mode-card:first-child .agent-mode-tag {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
}

.agent-mode-card:last-child .agent-mode-tag {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.agent-mode-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    padding: 12px;
    border: 1px solid #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.agent-mode-img {
    max-width: 100%;
    /* max-height: 280px; */
    border-radius: 8px;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
    object-fit: contain;
}

/* 智能体中心管理能力 */
.agent-center-management {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px dashed rgba(0, 0, 0, 0.1);
}

.management-card {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px;
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 12px;
    border: 1px solid rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.management-card:hover {
    transform: translateX(3px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.06);
}

.management-card:first-child {
    border-left: 3px solid #f59e0b;
}

.management-card:last-child {
    border-left: 3px solid #8b5cf6;
}

.management-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.4rem;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    flex-shrink: 0;
}

.management-content {
    flex: 1;
}

.management-title {
    font-size: 1rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.management-desc {
    font-size: 0.8rem;
    color: #64748b;
    line-height: 1.5;
    margin-bottom: 10px;
}

.management-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.management-tag {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 0.7rem;
    font-weight: 500;
}

.management-card:first-child .management-tag {
    background: rgba(245, 158, 11, 0.1);
    color: #f59e0b;
}

.management-card:last-child .management-tag {
    background: rgba(139, 92, 246, 0.1);
    color: #8b5cf6;
}

@media (max-width: 1200px) {
    .agent-center-content {
        grid-template-columns: 1fr;
    }

    .agent-mode-img {
        max-height: 220px;
    }

    .agent-center-management {
        grid-template-columns: 1fr;
    }
}

/* ── Workflow Orchestration Slide ── */
.slide-workflow .container {
    max-width: 100%;
    width: 100%;
    background: var(--card);
    border-radius: 24px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.08);
    padding: 40px;
}

.workflow-header {
    text-align: center;
    margin-bottom: 30px;
}

.workflow-title {
    font-size: clamp(1.6rem, 3vw, 2.2rem);
    font-weight: 700;
    color: var(--fg);
    margin-bottom: 10px;
    display: inline-flex;
    align-items: center;
    gap: 15px;
}

.workflow-title::before {
    content: '';
    width: 5px;
    height: 36px;
    background: linear-gradient(180deg, #f59e0b, #ef4444);
    border-radius: 3px;
}

.workflow-subtitle {
    font-size: clamp(0.9rem, 1.2vw, 1.1rem);
    color: var(--muted);
}

.workflow-content {
    /* display: grid;
    grid-template-columns: 1.4fr 1fr;
    gap: 30px;
    align-items: start; */
}

.workflow-left {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.workflow-screenshot {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 16px;
    padding: 15px;
    border: 1px solid #e2e8f0;
    min-height: 380px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.workflow-img {
    max-width: 100%;
    /* max-height: 350px; */
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    object-fit: contain;
}

.workflow-nodes {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.workflow-category {
    background: linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%);
    border-radius: 10px;
    padding: 14px 16px;
    border-left: 3px solid #3b82f6;
    transition: all 0.3s ease;
}

.workflow-category:hover {
    transform: translateX(3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.workflow-category:nth-child(1) {
    border-left-color: #3b82f6;
}

.workflow-category:nth-child(2) {
    border-left-color: #f59e0b;
}

.workflow-category:nth-child(3) {
    border-left-color: #10b981;
}

.workflow-category:nth-child(4) {
    border-left-color: #ef4444;
}

.workflow-category:nth-child(5) {
    border-left-color: #8b5cf6;
}

.workflow-category:nth-child(6) {
    border-left-color: #06b6d4;
}

.workflow-category-title {
    font-size: 0.9rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.workflow-category-desc {
    font-size: 0.75rem;
    color: #64748b;
    line-height: 1.4;
    margin-bottom: 8px;
}

.workflow-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
}

.workflow-tag {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 0.7rem;
    font-weight: 500;
}

.workflow-tag.blue {
    background: rgba(59, 130, 246, 0.1);
    color: #3b82f6;
}

.workflow-tag.purple {
    background: rgba(139, 92, 246, 0.1);
    color: #8b5cf6;
}

.workflow-tag.orange {
    background: rgba(245, 158, 11, 0.1);
    color: #f59e0b;
}

.workflow-tag.green {
    background: rgba(16, 185, 129, 0.1);
    color: #10b981;
}

.workflow-tag.cyan {
    background: rgba(6, 182, 212, 0.1);
    color: #06b6d4;
}

.workflow-tag.red {
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
}

/* 编排能力 */
.workflow-capabilities {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 12px;
}

.capability-card {
    background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
    border-radius: 10px;
    padding: 12px 10px;
    text-align: center;
    border: 1px solid rgba(0, 0, 0, 0.06);
    transition: all 0.3s ease;
}

.capability-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
}

.capability-icon {
    font-size: 1.3rem;
    margin-bottom: 6px;
}

.capability-title {
    font-size: 0.8rem;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 4px;
}

.capability-desc {
    font-size: 0.65rem;
    color: #64748b;
    line-height: 1.3;
}

@media (max-width: 1200px) {
    .workflow-content {
        grid-template-columns: 1fr;
    }

    .workflow-screenshot {
        min-height: 350px;
        order: 2;
    }

    .workflow-img {
        max-height: 320px;
    }

    .workflow-nodes {
        order: 1;
    }

    .workflow-capabilities {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 768px) {
    .workflow-capabilities {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {

    html,
    body {
        overflow-x: hidden;
        max-width: 100vw;
    }

    .slide,
    .slide>.container,
    .title-container {
        width: 100%;
        max-width: 100vw;
        overflow-x: hidden;
    }

    .slide-api-integration .container,
    .slide-permission-management .container,
    .slide-task-management .container,
    .slide-orchestration .container,
    .slide-paradigms .container,
    .slide-skill-intro .container,
    .slide-plugin-intro .container,
    .slide-kb-showcase .container,
    .slide-agent-showcase .container,
    .slide-agent-center .container,
    .slide-workflow .container,
    .slide-positioning .container {
        padding: 24px 16px;
        border-radius: 18px;
    }

    .api-header,
    .permission-header,
    .task-header,
    .orchestration-header,
    .paradigm-header,
    .skill-intro-header,
    .plugin-intro-header,
    .kb-showcase-header,
    .agent-showcase-header,
    .agent-center-header,
    .workflow-header,
    .positioning-header {
        margin-bottom: 18px;
    }

    .api-title,
    .permission-title,
    .task-title,
    .orchestration-title,
    .paradigm-title,
    .skill-intro-title,
    .plugin-intro-title,
    .kb-showcase-title,
    .agent-showcase-title,
    .agent-center-title,
    .workflow-title,
    .positioning-title {
        gap: 10px;
    }

    .api-title::before,
    .permission-title::before,
    .task-title::before,
    .orchestration-title::before,
    .paradigm-title::before,
    .skill-intro-title::before,
    .plugin-intro-title::before,
    .kb-showcase-title::before,
    .agent-showcase-title::before,
    .agent-center-title::before,
    .workflow-title::before,
    .positioning-title::before {
        height: 28px;
    }

    .api-pillars,
    .permission-pillars,
    .task-pillars,
    .skill-intro-pillars,
    .plugin-pillars,
    .kb-pillars,
    .agent-showcase-pillars,
    .agent-center-content,
    .agent-center-management,
    .workflow-content,
    .workflow-capabilities,
    .paradigm-grid,
    .api-content,
    .permission-content,
    .task-content,
    .skill-intro-content,
    .plugin-intro-content,
    .kb-showcase-grid,
    .agent-showcase-grid,
    .orchestration-content,
    .orchestration-bottom,
    .positioning-compare {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .platform-screenshot,
    .orchestration-screenshot,
    .workflow-screenshot,
    .skill-intro-screenshot,
    .plugin-intro-screenshot,
    .api-screenshot,
    .permission-screenshot,
    .task-screenshot,
    .agent-mode-screenshot,
    .kb-image-wrap,
    .agent-showcase-image-wrap {
        padding: 10px;
        overflow: hidden;
    }

    .platform-screenshot,
    .orchestration-screenshot,
    .workflow-screenshot,
    .agent-mode-screenshot {
        justify-content: center;
    }

    .screenshot-img,
    .orchestration-img,
    .workflow-img,
    .agent-mode-img,
    .skill-intro-image,
    .plugin-intro-image,
    .kb-image,
    .agent-showcase-image,
    .task-image,
    .permission-image,
    .api-image {
        width: 100%;
        min-width: 0;
        max-width: 100%;
        height: auto;
        max-height: none;
        object-fit: contain;
        object-position: top center;
    }

    .platform-screenshot,
    .orchestration-screenshot,
    .workflow-screenshot {
        min-height: auto;
    }

    .agent-showcase-body,
    .kb-card-body,
    .agent-mode-card,
    .skill-intro-card,
    .plugin-intro-card,
    .api-card,
    .permission-card,
    .task-card,
    .workflow-category,
    .orch-category,
    .management-card {
        padding-left: 14px;
        padding-right: 14px;
    }

    .agent-showcase-card-desc,
    .kb-card-desc {
        min-height: auto;
    }

    .title-main,
    .title-sub,
    .title-slogan,
    .issues-subtitle,
    .description {
        max-width: 100%;
        word-break: break-word;
        overflow-wrap: anywhere;
        text-align: center;
    }

    .flow-step,
    .mem-badge {
        white-space: normal;
    }

    .flow-branch-options,
    .claw-security-layers,
    .claw-fault-features,
    .skill-modes,
    .guarantee-row {
        flex-wrap: wrap;
    }

    .sec-layer,
    .fault-feature,
    .legend-items,
    .architecture-highlights,
    .guarantee-item {
        min-width: 0;
    }

    .node-grid,
    .knowledge-grid {
        grid-template-columns: 1fr !important;
    }
}
</style>

<style scoped>
.mindex {
    font-size: 22px !important;
    font-weight: bold !important;
    background: #fff !important;
    color: #333 !important;
}

.menu:hover {
    background: #fff;
    color: #333 !important;
}

.scroll-container::-webkit-scrollbar {
    /* WebKit */
    display: none;
}

/* .cardx:last-child{
    margin-right: auto;
    margin-left: 60px;
} */
/* .flex-container::after {
            content: "";
            flex: auto;
        } */
</style>